/* eslint-disable no-const-assign */
import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Link, withRouter } from "react-router-dom";
import moment from "moment";
import _ from "lodash";
import "./../../../assets/css/requestimates.css";
import Requestimate from "./requestimate";
import RequestimateState from "./requestimateState";
import { SelectCalendar } from "./../../partial/selectCalendar";
import DeleteOrLossModal from "./../../partial/DeleteOrLossModal";
import DepositRefundModal from "./../../partial/DepositRefundModal";
import ItemMaterialCaptureModal from "./../../partial/ItemMaterialCaptureModal";
import ServiceItemsModal from "./../../partial/ServiceItemsModal";
import ItemCompletionGuardModal from "./../../partial/ItemCompletionGuardModal";
import VINRequiredModal from "./../../partial/VINRequiredModal";
import CarFaxDataModal from "./../../partial/CarFaxDataModal";
import { Modal, Button, Form } from 'react-bootstrap';
import { isMultiLocation, isAllLocations, getLocationName, getLocationBadgeColor } from "../../../util/locationUtils";
import { HTTPService } from "./../../../services/httpService";
import InventoryAPI from "./../../../services/inventoryService";
import serviceItemsService from "./../../../services/serviceItemsService";
import { convertToUTC, convertFromUTC } from "../../../util/convert_timezone";
import ReactGA from "react-ga4";

//import stripe from 'stripe';
const API = new HTTPService();

const isUnclaimed = (item) => {
  const locId = item.location_id || item.locationId;
  return !locId || locId === 0 || locId === '0';
};

class Requestimates extends Component {
  state = {
    requestimates: [],
    estimates: [],
    requestOffers: [],
    requestStates: [],
    requestNotes: [],
    calendarDays: [],
    excludeDays: [],
    customerId: 0,
    customerName: "",
    customemrEmail: "",
    customerPhone: "",
    selectedRequestimate: {},
    selectedInstaller: "",
    invoice: {},
    activePage: 1,
    installer: {},
    selectedOffer: {},
    selectedOffers: [],
    startDate: new moment().format("YYYY-MM-DD"),
    template: "",
    materials: "",
    vin: "",
    vehicleEntered: {},
    vinGood: false,
    reviewScore: 0,
    selectedPay: "Pay Online",
    checkNumber: "",
    availableDate: {},
    selectedService: 0,
    services: [],
    prevMode: "",
    userType: this.props.userType,
    typeId: this.props.typeId,
    user: this.props.user,
    companyName: this.props.companyName,
    company: this.props.company,
    hiddenList: false,
    showSwipe: false,
    showPO: false,
    paymentState: "idle",           // NEW: Track payment progress state
    paymentError: null,             // NEW: Store payment error messages
    paymentPollInterval: null,      // NEW: Store polling interval ID
    terminalState: "offline",       // Existing, but enhanced
    paymentIntentId: "",
    authenticated: 0,
    calendar: "",
    loading: false,
    rowSelected: false,
    showCalendar: false,
    showHelpVideo: false,
    showDepositModal: false,
    showDeleteOrLossModal: false,
    requestToDelete: null,
    showDepositRefundModal: false,
    depositRefundPayment: null,
    deleteConfirmResult: null,
    showRejectModal: false,
    requestToReject: null,
    vehicleImages: [],

    // CarFax Data State (from checkin/status)
    checkinOdometerReading: null,
    checkinPlate: null,
    checkinCarfaxOptOut: false,

    // CarFax Data Modal State (for handleComplete guard)
    showCarFaxDataModal: false,
    carfaxDataRequest: null,
    carfaxDataServicesArray: null,

    // Split Payment State
    isSplitPayment: false,              // Split payment mode active?
    collectedPayments: [],              // Array of collected split payment records
    splitPaymentAmount: '',             // Input: amount for current split payment
    selectedSplitMethod: null,          // 'Terminal' | 'Online' | 'Cash' | 'Check'
    splitCheckNumber: '',               // Check number for check payments
    finalInvoiceId: null,               // Stripe invoice ID for final invoice
    isProcessingSplitPayment: false,    // Loading state during split payment processing
    splitPaymentError: null,            // Error message for split payments
    showInvoiceLinkModal: false,        // Show modal with invoice link (for online payments)
    currentInvoiceLink: null,           // Invoice URL for online split payments

    // Materials Collection State
    categoryConfigs: {},                 // Service category configs (data_collect settings)

    // Technician Assignment State
    technicians: [],                     // List of technicians at this company
    savingInstructions: false,           // Loading state for saving instructions

    // Product Selection State
    categoryHasProducts: {},             // Map of category name -> boolean

    // Service Items State
    showServiceItemsModal: false,        // Show ServiceItemsModal
    serviceItemsModalService: null,      // Service object for ServiceItemsModal
    itemsByServiceId: {},                // Cache: { requestServiceId: [items] }
    showItemGuardModal: false,           // Show ItemCompletionGuardModal
    itemGuardData: null,                 // { serviceName, taskStatus, retryCallback }

    // Per-Item Material Capture State
    showItemCaptureModal: false,
    itemCaptureService: null,            // Service object for ItemMaterialCaptureModal
    itemCaptureItems: [],                // Material items for the modal
    itemCaptureRequest: null,            // Request context for finish callback
    itemCaptureJob: null,                // Job context for finish callback

    // VIN Required Modal State (for handleCompleteEstimate)
    showVINRequiredModal: false,
    vinRequiredRequest: null,
    vinRequiredStartDate: null,

    // Refresh state
    refreshing: false,

    // Stripe Capability Validation
    stripeCapabilities: {},

    // Filter state
    listFilter: '',
    showFilterDropdown: false,

    // Assign Location Modal State (multi-location unclaimed requests)
    showAssignLocationModal: false,
    assignLocationRequest: null,
    assignLocationCallback: null,
    modalSelectedLocationId: '',
  };

  // Refresh the list data
  handleRefresh = () => {
    this.setState({ refreshing: true });
    window.location.reload();
  };

  async componentDidMount() {
    const { typeId, userType } = this.state;

    // Determine request endpoint based on userType
    // Fetch ALL requests regardless of location — client-side filtering applied in render()
    const installerRequest = userType === "dealer"
      ? `/requestimates/getdealerrequests/?Id=${typeId}`
      : `/requestimates/getinstallerrequests/?Id=${typeId}`;

    if (userType === "installer") {
      // PARALLEL: Fire all independent API calls at once
      const calLocParam = this.props.selectedLocationId && this.props.selectedLocationId !== 'all'
        ? `?locationId=${this.props.selectedLocationId}` : '';
      const [
        requestimatesResponse,
        installerResponse,
        dealerCalendarResponse,
        installerCalendarResponse,
        estimatesResponse,
        authResponse,
        companiesResponse,
        categoryConfigsResponse,
        techniciansResponse,
        categoryProductsResponse
      ] = await Promise.all([
        API.get(installerRequest),
        API.get(`/installerLocations/${typeId}`),
        API.get(`/dealerCalendars/${typeId}${calLocParam}`),
        API.get(`/installerCalendars/${typeId}${calLocParam}`),
        API.get(`/requestimates/getinstallerestimates/?Id=${typeId}`),
        API.get(`/installerAuth/${typeId}`),
        API.get(`/userAccess/${this.props.user.User_id}`),
        API.get('/serviceCategoryConfig'),
        API.get(`/users?company_id=${typeId}&user_type=installer`).catch(() => ({ data: [] })),
        InventoryAPI.getProducts(typeId).catch(() => [])
      ]);

      // Process installer data
      const installerData = installerResponse.data;
      const installer = installerData.shift();

      // Process auth data
      const authData = authResponse.data[0] || {};

      // Process assignable staff (owners + technicians)
      const assignableRoles = ['owner', 'manager', 'technician'];
      const techRaw = (techniciansResponse.data || []).filter(u => assignableRoles.includes(u.role || u.user_role));
      const seenIds = new Set();
      const technicians = techRaw.filter(u => {
        if (seenIds.has(u.User_id)) return false;
        seenIds.add(u.User_id);
        return true;
      }).sort((a, b) => (a.user_name || '').localeCompare(b.user_name || ''));

      // Process category configs
      const categoryConfigs = {};
      if (Array.isArray(categoryConfigsResponse.data)) {
        categoryConfigsResponse.data.forEach(config => {
          categoryConfigs[config.category_name] = config;
        });
      }

      // Process category products
      const categoryHasProducts = {};
      const products = Array.isArray(categoryProductsResponse) ? categoryProductsResponse : (categoryProductsResponse?.data || []);
      products.forEach(product => {
        if (product.category_name) {
          categoryHasProducts[product.category_name] = true;
        }
      });

      // Process calendars
      const dealerCalendarDays = dealerCalendarResponse.data || [];
      const installerCalendarDays = installerCalendarResponse.data || [];
      const calendarList = dealerCalendarDays.concat(installerCalendarDays);
      const calendarDays = _.orderBy(calendarList, ["workDate"], ["asc"]);

      // Calculate booked capacity for next 60 days
      let excludeDays = [];
      if (calendarDays.length > 0) {
        const startDate = moment.utc().format("YYYY-MM-DD");
        const totalDuration = 60;

        const bookedArray = calendarDays.filter(
          (day) => moment.utc(day.workDate).diff(startDate) >= 0
        );

        const bookedData = new Array(totalDuration);
        for (let m = 0; m < totalDuration; m++) {
          bookedData[m] = {
            x: m,
            exDate: moment.utc(startDate).add(m, "days").format("YYYY-MM-DD"),
            y: 0,
          };
        }

        for (let k = 0; k < bookedData.length; k++) {
          const matchingWork = bookedArray.filter(
            (work) =>
              moment.utc(work.workDate).format("YYYY-MM-DD") === bookedData[k].exDate
          );
          bookedData[k].y = matchingWork.reduce((result, value) => result + value.capacity, 0);
        }
        excludeDays = bookedData;
      }

      // Combine requestimates and estimates
      const requestimates = requestimatesResponse.data || [];
      const estimates = estimatesResponse.data || [];
      const allRequestimates = _.orderBy(
        requestimates.concat(estimates),
        ["availableDate"],
        ["asc"]
      );

      // Single setState with all data
      this.setState({
        installer,
        authenticated: authData.authenticated,
        calendar: authData.calendar_id,
        companies: companiesResponse.data,
        technicians,
        categoryConfigs,
        categoryHasProducts,
        calendarDays,
        excludeDays,
        estimates,
        requestimates: allRequestimates
      });

      // Stripe capabilities now validated server-side at action time (decision #7)

      await this.clearRequestimate();

    } else {
      // DEALER: Parallel fetch requests and offers
      const [requestimatesResponse, requestOffersResponse] = await Promise.all([
        API.get(installerRequest),
        API.get(`/requestOffered/${typeId}`)
      ]);

      const requestimates = requestimatesResponse.data || [];
      const tempRequestOffers = requestOffersResponse.data || [];
      const requestOffers = tempRequestOffers.filter(
        (item) => item.currentStatus === "accepted"
      );

      this.setState({ requestimates, requestOffers });
    }
  }

  componentDidUpdate(prevProps) {
    // Clear selected requestimate when mode changes (requests <-> jobs <-> pickups)
    // or when filter changes (scheduled <-> inprogress)
    const prevFilter = new URLSearchParams(prevProps.location?.search || '').get('filter');
    const currentFilter = new URLSearchParams(this.props.location?.search || '').get('filter');

    if (prevProps.mode !== this.props.mode || prevFilter !== currentFilter) {
      this.setState({
        selectedRequestimate: {},
        vehicleImages: [],
        checkinOdometerReading: null,
        checkinPlate: null,
        checkinCarfaxOptOut: false,
        listFilter: '',
        showFilterDropdown: false
      });
    }
  }

  componentWillUnmount() {
  if (this.availabilityTimeout) {
    clearTimeout(this.availabilityTimeout);
  }
  this.availabilityFetching = false;

  // FIX: Clean up payment polling when component unmounts
  if (this.state.paymentPollInterval) {
    console.log("Component unmounting - clearing payment polling");
    clearInterval(this.state.paymentPollInterval);
  }

  // FIX: Clear polling timeout
  if (this.pollTimeout) {
    clearTimeout(this.pollTimeout);
  }

  // FIX: Reset invoice settlement flag
  this.invoiceSettled = false;
}

  // Database updates when needed for each of the state changes
  readInstaller = async (installerId) => {
    let installerRequest = `/installerLocations/${installerId}`;
    const { data: installer } = await API.get(installerRequest);
    //    //console.log("Installer in Requestimates:", installer);
    const firstOne = installer.shift();
    this.setState({ installer: firstOne });
  };

  readAuth = async (installerId) => {
    let installerRequest = `/installerAuth/${installerId}`;
    const { data: installer } = await API.get(installerRequest);
    //  //console.log("Installer :", installer);
    this.setState({
      authenticated: installer[0].authenticated,
      calendar: installer[0].calendar_id,
    });
  };

  readCompanies = async (userId) => {
    let companyList = `/userAccess/${userId}`;
    const { data: installer } = await API.get(companyList);
    //    //console.log("Installer Companies:", installer);
    this.setState({ companies: installer });
  };

  // Load technicians for this company (for assignment feature)
  loadTechnicians = async () => {
    try {
      const { typeId } = this.state;
      const { data: users } = await API.get(`/users?company_id=${typeId}&user_type=installer`);
      // Filter to owners + technicians (dedupe by User_id in case API returns duplicates)
      const techRaw = (users || []).filter(u => ['owner', 'manager', 'technician'].includes(u.role || u.user_role));
      const seenIds = new Set();
      const technicians = techRaw.filter(u => {
        if (seenIds.has(u.User_id)) return false;
        seenIds.add(u.User_id);
        return true;
      });
      this.setState({ technicians });
    } catch (error) {
      console.error('Error loading technicians:', error);
      this.setState({ technicians: [] });
    }
  };

  // Load products and build map of which categories have products (for product selection)
  loadCategoryProducts = async () => {
    try {
      const { typeId, userType } = this.state;
      // Only load for installers
      if (userType !== 'installer') return;

      const products = await InventoryAPI.getProducts(typeId);

      // Build map of category_name -> true for categories that have products
      const categoryHasProducts = {};
      (products || []).forEach(product => {
        if (product.category_name) {
          categoryHasProducts[product.category_name] = true;
        }
      });

      this.setState({ categoryHasProducts });
    } catch (error) {
      console.error('Error loading category products:', error);
    }
  };

  // Assign a technician to a service
  handleAssignTechnician = async (requestId, serviceId, technicianId, requestServiceId) => {
    try {
      const { user } = this.props;
      const patchUrl = requestServiceId
        ? `/requestService/row/${requestServiceId}`
        : `/requestService/${requestId}/${serviceId}`;
      await API.patch(patchUrl, {
        assigned_technician_id: technicianId,
        technician_assigned_at: technicianId ? convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss") : null,
        technician_assigned_by: technicianId ? user.User_id : null
      });

      // Update the services in state to reflect the change
      const updatedServices = this.state.services.map(s =>
        (requestServiceId ? s.id === requestServiceId : s.service_id === serviceId)
          ? { ...s, assigned_technician_id: technicianId }
          : s
      );
      this.setState({ services: updatedServices });

    } catch (error) {
      console.error('Error assigning technician:', error);
      alert('Error assigning technician. Please try again.');
    }
  };

  // Save technician instructions for a service
  handleSaveInstructions = async (requestId, serviceId, instructions, requestServiceId) => {
    try {
      this.setState({ savingInstructions: true });
      const { user } = this.props;

      const patchUrl = requestServiceId
        ? `/requestService/row/${requestServiceId}`
        : `/requestService/${requestId}/${serviceId}`;
      await API.patch(patchUrl, {
        technician_instructions: instructions,
        instructions_added_by: user.User_id,
        instructions_added_at: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss")
      });

      // Update the services in state to reflect the change
      const updatedServices = this.state.services.map(s =>
        (requestServiceId ? s.id === requestServiceId : s.service_id === serviceId)
          ? { ...s, technician_instructions: instructions }
          : s
      );
      this.setState({ services: updatedServices, savingInstructions: false });

    } catch (error) {
      console.error('Error saving instructions:', error);
      alert('Error saving instructions. Please try again.');
      this.setState({ savingInstructions: false });
    }
  };

  // Open ServiceItemsModal for a service (called from cube button)
  handleSelectProduct = (serviceRow) => {
    this.setState({
      showServiceItemsModal: true,
      serviceItemsModalService: serviceRow
    });
  };

  // Callback when items are changed in ServiceItemsModal
  handleItemsChanged = async () => {
    const { serviceItemsModalService, services } = this.state;
    if (!serviceItemsModalService?.id) return;

    try {
      const items = await serviceItemsService.getItems(serviceItemsModalService.id);
      const materialItems = (items || []).filter(i => !i.type || i.type === 'material');

      // Update items cache
      const itemsByServiceId = { ...this.state.itemsByServiceId };
      itemsByServiceId[serviceItemsModalService.id] = materialItems;

      // Merge items onto service rows for display
      const updatedServices = services.map(s =>
        s.id === serviceItemsModalService.id
          ? { ...s, items: materialItems }
          : s
      );

      this.setState({ itemsByServiceId, services: updatedServices });
    } catch (error) {
      console.error('Error refreshing items after change:', error);
    }
  };

  // Load service items for services that have them (task_count > 0 or items exist)
  loadServiceItems = async (services) => {
    if (!services || services.length === 0) return;

    // Find services with task_count > 0 (indicates items exist)
    const servicesWithItems = services.filter(s => s.id && s.task_count > 0);
    if (servicesWithItems.length === 0) return;

    try {
      const itemsByServiceId = {};

      // Fetch items for each service in parallel (silent = no toast on errors)
      const results = await Promise.all(
        servicesWithItems.map(s =>
          serviceItemsService.getItems(s.id, { silent: true })
        )
      );

      servicesWithItems.forEach((service, i) => {
        const allItems = results[i] || [];
        const materialItems = allItems.filter(item => !item.type || item.type === 'material');
        itemsByServiceId[service.id] = materialItems;
      });

      // Merge items onto service rows for display
      const updatedServices = this.state.services.map(s => {
        if (itemsByServiceId[s.id]) {
          return { ...s, items: itemsByServiceId[s.id] };
        }
        return s;
      });

      this.setState({ itemsByServiceId, services: updatedServices });
    } catch (error) {
      console.error('Error loading service items:', error);
    }
  };

  // Load service category configs for materials tracking
  loadCategoryConfigs = async () => {
    try {
      const { data: configs } = await API.get('/serviceCategoryConfig');
      // Convert array to lookup object by category_name
      const categoryConfigs = {};
      if (Array.isArray(configs)) {
        configs.forEach(config => {
          categoryConfigs[config.category_name] = config;
        });
      }
      this.setState({ categoryConfigs });
      console.log("Loaded category configs:", categoryConfigs);
    } catch (error) {
      console.error("Error loading category configs:", error);
    }
  };

  updateInstallerLocation = async (location) => {
    let calendar = {
      installerId: this.props.typeId,
      calendarId: location,
    };
    let userLoc = `/updateLocation/${this.props.typeId}`;
    await API.put(userLoc, calendar);
  };

  // Add new handler methods (add these before the existing handlers)

  handleShowDepositModal = (request) => {
    this.setState({ showDepositModal: true });
  };

  handleHideDepositModal = () => {
    this.setState({ showDepositModal: false });
  };

handleSaveDeposit = async (request, depositAmount) => {
  try {
    const updatedRequest = { 
      ...request, 
      deposit_amount: depositAmount,  // Backend still expects snake_case
      depositAmount: depositAmount    // Frontend uses camelCase
    };
    await this.updateRequest(updatedRequest);
    
    this.setState({ 
      selectedRequestimate: updatedRequest
    });
    
    //console.log('Deposit amount updated:', depositAmount);
  } catch (error) {
    console.error('Error saving deposit amount:', error);
    throw error;
  }
};
handleCreateDepositInvoice = async (request) => {
  try {
    // Check if Stripe capabilities are active
    if (!this.validateStripeCapabilities()) return null;

    if (!request.depositAmount || request.depositAmount <= 0) {
      throw new Error('No deposit amount set');
    }

    // Get installer ID
    const installerId = request.assignedTo || this.state.typeId;

    // Fetch tax rate from Stripe for this installer
    let taxRatePercentage = 0;
    let stripeTaxRateId = null;

    try {
      // Get installer's location and tax rate
      const installerRequest = `/installerLocations/${installerId}`;
      const { data: installers } = await API.get(installerRequest);

      if (installers && installers[0] && installers[0].stripe_tax_rate) {
        stripeTaxRateId = installers[0].stripe_tax_rate;
        const taxRequest = `/taxes/${stripeTaxRateId}`;
        const { data: taxRate } = await API.get(taxRequest);
        taxRatePercentage = taxRate.percentage || 0;

        console.log(`Tax rate retrieved for installer ${installerId}: ${taxRatePercentage}%`);
      } else {
        console.warn(`No tax rate found for installer ${installerId}, proceeding without tax adjustment`);
      }
    } catch (taxError) {
      console.error('Error fetching tax rate:', taxError);
      console.warn('Continuing without tax adjustment');
      // Continue without tax adjustment if we can't fetch it
    }

    // Calculate base amount so that base + tax = quoted deposit amount
    const quotedDepositAmount = request.depositAmount;
    const taxMultiplier = 1 + (taxRatePercentage / 100);
    const baseAmount = quotedDepositAmount / taxMultiplier;
    const taxAmount = quotedDepositAmount - baseAmount;

    console.log(`Deposit Invoice Calculation:
      Quoted deposit amount: $${quotedDepositAmount.toFixed(2)}
      Tax rate: ${taxRatePercentage}%
      Base amount (pre-tax): $${baseAmount.toFixed(2)}
      Calculated tax: $${taxAmount.toFixed(2)}
      Total (base + tax): $${(baseAmount * taxMultiplier).toFixed(2)}
    `);

    const invoice = {
      invoiceId: `${request.requestId}-deposit-${Date.now()}`,
      invoiceType: request.requestType,
      amount: baseAmount,  // Send base amount - Stripe will add tax to reach quoted amount
      quotedAmount: quotedDepositAmount,  // Store original quoted amount for reference
      description: `Deposit for ${request.serviceRequested}`,
      metadata: {
        payment_type: 'deposit',
        request_id: request.requestId,
        installer_id: installerId,
        quoted_deposit_amount: quotedDepositAmount.toString(),
        tax_rate_percentage: taxRatePercentage.toString(),
        stripe_tax_rate_id: stripeTaxRateId
      }
    };

    console.log('Creating deposit invoice with data:', invoice);

    const apiEndpoint = `/invoices/`;
    const { data: depositInvoice } = await API.post(apiEndpoint, invoice);

    console.log('Deposit invoice created successfully:', depositInvoice);
    return depositInvoice;

  } catch (error) {
    console.error('Error creating deposit invoice:', error);
    throw error;
  }
};

handleTransferLocation = (request) => {
  this.setState({
    showAssignLocationModal: true,
    assignLocationRequest: request,
    assignLocationCallback: null,
    modalSelectedLocationId: ''
  });
};

  // --- Assign Location (multi-location unclaimed requests) ---

  handleAssignLocation = async (request, locationId) => {
    try {
      await API.patch(`/requestimates/${request.requestId}/location`, { locationId });

      // Update local state — both requestimates and estimates lists
      const updateList = (list) => list.map(r =>
        r.requestId === request.requestId ? { ...r, location_id: locationId } : r
      );
      const updatedRequestimates = updateList(this.state.requestimates);
      const updatedEstimates = updateList(this.state.estimates);

      // If viewing a specific location and assigned to a different one, clear selection
      const { selectedLocationId } = this.props;
      const transferredAway = !isAllLocations(selectedLocationId)
        && String(locationId) !== String(selectedLocationId);

      const updatedSelected = transferredAway
        ? {}
        : (this.state.selectedRequestimate?.requestId === request.requestId
          ? { ...this.state.selectedRequestimate, location_id: locationId }
          : this.state.selectedRequestimate);

      this.setState({
        requestimates: updatedRequestimates,
        estimates: updatedEstimates,
        selectedRequestimate: updatedSelected,
        hiddenList: transferredAway ? false : this.state.hiddenList
      });
    } catch (error) {
      console.error('Error assigning location:', error);
      alert('Failed to assign location. Please try again.');
    }
  };

  requireLocationAssignment = (request, callback) => {
    const { locations } = this.props;
    if (isMultiLocation(locations) && isUnclaimed(request)) {
      this.setState({
        showAssignLocationModal: true,
        assignLocationRequest: request,
        assignLocationCallback: callback,
        modalSelectedLocationId: ''
      });
      return true;
    }
    return false;
  };

  readRequestServices = async (request) => {
    let serviceRequest = `/requestService/${request}`;
    const { data: services } = await API.get(serviceRequest);
    for (let i = 0; i < services.length; i++) {
      if (services[i].custom_description) {
        services[i].Description = services[i].custom_description;
      }
    }
    this.setState({ services });
  };

  readVIN = async (vin) => {
    const vinRequest = `/vin/?Id=${vin}`;
    const { data: vehicle } = await API.get(vinRequest);
    this.setState({ vehicleEntered: vehicle.Results[0] });
  };


  readPayment = async (request) => {
    const paymentRequest = `/installerPaymentsRequest/${request}`;
    const { data: payment } = await API.get(paymentRequest);
    //    //console.log ("readPayment : ", payment);
    this.setState({ payment });
  };

  readRequestNotes = async (request) => {
    let noteRequest = `/requestnotes/${request}`;
    const { data: notes } = await API.get(noteRequest);
    this.setState({ requestNotes: notes });
  };

  readRequestOffers = async (request) => {
    let offerRequest = `/requestoffered/request/${request}`;
    const { data: offers } = await API.get(offerRequest);
    this.setState({ requestOffers: offers });
  };

readInvoice = async (invoiceId) => {
  if (invoiceId) {
    let invoiceRequest = `/invoices/${invoiceId}`;
    const { data: invoice } = await API.get(invoiceRequest);
    //console.log("Invoice data:", invoice); // Debug: Check what's in the invoice
    //console.log("Invoice number:", invoice.number); // Debug: Check the number field
    this.setState({
      invoice,
      finalInvoiceId: invoice.id // Set finalInvoiceId for split payment feature
    });
    
    // Add the invoice number to selectedRequestimate
    if (this.state.selectedRequestimate && invoice.number) {
      //console.log("Current selectedRequestimate:", this.state.selectedRequestimate); // Debug
      const updatedRequestimate = {
        ...this.state.selectedRequestimate,
        customer_facing_invoice: invoice.number
      };
      //console.log("Updated selectedRequestimate:", updatedRequestimate); // Debug
      this.setState({ selectedRequestimate: updatedRequestimate });
    } else {
      /*console.log("Conditions not met:", {
        hasSelectedRequestimate: !!this.state.selectedRequestimate,
        hasInvoiceNumber: !!invoice.number
      });*/
    }
  } else {
    this.setState({
      invoice: {},
      finalInvoiceId: null // Clear finalInvoiceId when no invoice
    });
  }
};

  readRequestStates = async (request) => {
    let stateRequest = `/requeststate/${request.requestId}`;
    const { data: history } = await API.get(stateRequest);
    let selectHistory = history.filter(
      (item) => item.requestId === request.requestId
    );

    this.setState({ requestStates: selectHistory });
  };

  updateRequestOffered = async (offer) => {
    const apiEndpoint = `/requestOffered/${offer.requestId}`;
    await API.put(apiEndpoint, offer);
    //    //console.log('updateRequestOffered', post);
    return null;
  };
  updateRequestOfferedState = async (offer) => {
    const apiEndpoint = `/requestoffered/state/${offer.requestId}`;
    await API.put(apiEndpoint, offer);
    //    //console.log('updateRequestOffered', post);
    return null;
  };

  updateRequestServices = async (requestService) => {
    //    //console.log('updating request service');
    //    //console.log(requestService);
    const apiEndpoint = `/requestServiceState/${requestService.requestServiceId}`;
    await API.put(apiEndpoint, requestService);
    //    //console.log(post);
    return null;
  };

  updateRequestAllServices = async (requestService) => {
    //  //console.log('updating all request service');
    //  //console.log(requestService);
    const apiEndpoint = `/requestAllService/${requestService.requestId}`;
    await API.put(apiEndpoint, requestService);
    //  //console.log(post);
    return null;
  };

updateRequest = async (request) => {
  request.createdDate = convertToUTC(request.createdDate).format(
    "YYYY-MM-DD HH:mm:ss"
  );
  request.availableDate = convertToUTC(request.availableDate).format(
    "YYYY-MM-DD HH:mm:ss"
  );
  request.dueDate = convertToUTC(request.dueDate).format(
    "YYYY-MM-DD HH:mm:ss"
  );

  let apiEndpoint = `/requestimates/requestbyID/?Id=${request.requestId}`;
  await API.put(apiEndpoint, request);

  console.log('updateRequest called for:', request.requestId, 'state:', request.currentState);

  // COMPLETELY REMOVED: Automatic invoice creation when currentState === "finished"
  // This was the source of duplicate invoices when multiple paths led to completion
  
  /*
  // OLD CODE REMOVED TO PREVENT DUPLICATES:
  if (request.currentState === "finished") {
    const invoice = {
      invoiceId: request.requestId,
      invoiceType: request.requestType,
    };
    apiEndpoint = `/invoices/`;
    const { data: post } = await API.post(apiEndpoint, invoice);
    console.log("Here's the invoice created", post);
  }
  */
  
  console.log('updateRequest completed - no automatic invoice creation');
};

addRequestState = async (requestId, requeststate, requestService, reasonCode = null, reasonNotes = null) => {
  const state = {
    requestId: requestId,
    stateDate: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    requestStatus: requeststate,
    serviceId: requestService,
    // NEW: Add user tracking
    changedByUserId: this.state.user.User_id,
    changedByUserType: this.state.userType,
    // NEW: Add reason tracking for all state changes
    reasonCode: reasonCode,
    reasonNotes: reasonNotes,
    location_id: this.props.selectedLocationId || null
  };

  const apiEndpoint = `/requestState`;
  await API.post(apiEndpoint, state);
  return null;
};

  addAppointment = async (appointment) => {
    //   alert ("Add to the calendar");

    let readAppt = `/readAppt/${appointment}`;
    const { data: appt } = await API.get(readAppt);

       //console.log("Here's the data for the appointment :", appt);
    //     //console.log("Here's the rest of the appointment data :", this.state.selectedRequestimate);
    //    //console.log("description :", description);

    let calEntry = appt[0];

    let summary = `${calEntry.Year} ${calEntry.Make} ${calEntry.Model}`;
    let description = `Customer : ${this.state.selectedRequestimate.dealerName} ${this.state.selectedRequestimate.email} ${this.state.selectedRequestimate.phone_number}`;
    let newAppt = {
      request: appointment,
      summary: summary,
      description: description,
      calendar: calEntry.calendar_id,
      startDate: calEntry.work_date,
      duration: calEntry.request_duration,
      installerId: this.props.typeId,
    };

    let apptAdd = `/addAppt/`;
    await API.put(apptAdd, newAppt);
    return;
  };

  delAppointment = async (appointment) => {
    let readAppt = `/readAppt/${appointment}`;
    const { data: appt } = await API.get(readAppt);

    //  //console.log("Here's the data for the appointment :", appt);

    if (appt.length > 0) {
      if (appt[0].event_id) {
        let newAppt = {
          eventId: appt[0].event_id,
          installerId: this.props.typeId,
        };

        let apptDel = `/delAppt/`;
        await API.put(apptDel, newAppt);
      }
    }
  };

logPaymentFailure = async (failureType, stage, error, stripeObjectId = null) => {
  try {
    const failure = {
      request_id: this.state.selectedRequestimate?.requestId,
      failure_type: failureType,
      failure_stage: stage,
      error_message: error.message || error,
      user_id: this.state.typeId,
      user_type: this.state.userType,
      stripe_object_id: stripeObjectId
    };

    await API.post('/payment-failures', failure);
    console.log(`Payment failure logged: ${failureType} at ${stage}`);
  } catch (logError) {
    console.error('Failed to log payment failure:', logError);
    // Don't fail main operation if logging fails
  }
};

  addCustomer = async (customer) => {
    //  //console.log('Adding Customer Record');
    //  //console.log(customer);

    const apiEndpoint = `/customers`;
    const { data: customerId } = await API.post(apiEndpoint, customer);
    //  //console.log(customerId);
    this.setState({ customerId });
    return null;
  };

  updateCustomer = async (customer) => {
    //    //console.log('Updating Customer Record');
    //    //console.log(customer);
    let custRecord = {
      customerType: "Customer",
      owningInstaller: this.props.typeId,
    };
    const apiEndpoint = `/customers/${customer}`;
    await API.put(apiEndpoint, custRecord);
    //      //console.log(customerId);
    return null;
  };

  updatePayment = async (request, paymentMethod) => {
    //      //console.log('Updating Payment Record');
    const payment = {
      requestId: request.requestId,
      paymentDate: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      installerId: this.props.typeId,
      paymentState: "settled",
      paymentMethod: paymentMethod || null,
    };
    const apiEndpoint = "/installerPaymentSettle/" + request.requestId;
    await API.put(apiEndpoint, payment);
  };

  updateSchedule = async (offer, startDate) => {
    //    //console.log('Updating Schedule and booking');
    //    //console.log(offer,startDate);
    let scheduleRecord = {
      installerId: this.state.typeId,
      requestId: offer.requestId,
      installerCapacity: this.state.installer.installerCapacity,
      startDate: convertToUTC(startDate).format("MM-DD-YYYY"),
      location_id: this.props.selectedLocationId || null,
    };
    const apiEndpoint = `/schedule/`;
    await API.put(apiEndpoint, scheduleRecord);
    //      //console.log(scheduled);
  };

  updateVehicle = async (oldVin, newVin) => {
    //     //console.log('Updating vehicle record :' + oldVin + " with " + newVin);
    const vehicleEntry = {
      vin: newVin,
    };
    const apiEndpoint = `/vehiclesVIN/${oldVin}`;
    await API.put(apiEndpoint, vehicleEntry);
    //    //console.log( "returns : ", post)
    return null;
  };

  updateInstallerCalendar = async (request, service, state) => {
    //    //console.log('Updating calendar record :', request);
    //    //console.log('Updating calendar record :', service);
    //    //console.log('Updating calendar record :', state);

    let installerId = request.installerId;
    if (typeof installerId === "undefined") {
      installerId = this.props.typeId;
    }

    const calendarEntry = {
      requestId: request.requestId,
      installerId: installerId,
      serviceId: service,
      workDate: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      workStatus: state,
      location_id: request.location_id || this.props.selectedLocationId || null,
    };

    let apiEndpoint = `/installerCalendarProgress/${calendarEntry.requestId}`;
    if (state !== "booked")
      apiEndpoint = `/installerCalendars/${calendarEntry.requestId}`;

    /* const { data: post } = */ await API.put(apiEndpoint, calendarEntry);

    if (service != null) {
      var calendarToChange = this.state.calendarDays;
      // find the request & service
      var dayIndex = calendarToChange.findIndex(
        (day) =>
          day.requestId === calendarEntry.requestId &&
          day.serviceId === calendarEntry.serviceId
      );
      // Only update if calendar entry exists in local state
      if (dayIndex !== -1) {
        calendarToChange[dayIndex].workStatus = calendarEntry.workStatus;
        this.setState({ calendarDays: calendarToChange });
      }
    }
    return null;
  };

  updateInvoiceMetadata = async (invoice, PO) => {
    const apiEndpoint = `/invoices/meta/${invoice}`;
    let transfer = { invoiceId: invoice, PO: PO };
    await API.put(apiEndpoint, transfer);
    ////console.log(post);
    return null;
  };

  createTransfer = async (transfer) => {
    const apiEndpoint = "/transfer";
    await API.post(apiEndpoint, transfer);
    ////console.log(post);
    return null;
  };

  settleInvoice = async (invoice) => {
    const apiEndpoint = "/invoices/settle/" + invoice;
    await API.put(apiEndpoint);
    ////console.log(post);
    return null;
  };

  deleteInstallerCalendar = async (offer) => {
    const calendarEntry = {
      requestId: offer.requestId,
      installerId: offer.installerId,
    };
    const apiEndpoint = `/installerCalendars/${offer.requestId}`;
    /* const { data: post } = */ await API.delete(apiEndpoint, calendarEntry);
    return null;
  };

  processPayment = async (payment, location) => {
    // create a new payment intent for thje terminal reader with the invoice amount on it
    // Process and capture the payment and mark the invoice as paid
    //    const reader = await stripe.terminal.readers.processPaymentIntent(
    //     location,
    //    {payment_intent: payment}
    //);
  };

  resendInvoice = async (invoice) => {
    // //console.log('Deleting Installer Calendar');
    //   //console.log("resendInvoice : ",invoice);
    const apiEndpoint = `/invoices/resend/${invoice}`;
    await API.put(apiEndpoint);
    //   //console.log("resendInvoice returned :",post);
  };

  finalizeInvoice = async (invoice) => {
    // //console.log('Deleting Installer Calendar');
    //    //console.log("finalizeInvoice : ",invoice);
    const apiEndpoint = `/invoices/finalize/${invoice}`;
    await API.put(apiEndpoint);
    //     //console.log("finalizeInvoice returned :",post);
  };

  deleteInvoice = async (invoice) => {
    // Remove the invoice if draft, and set to void if finalized
    ////console.log(offer);
    let apiEndpoint = `/invoices/${invoice}`;
    const { data: returnedInvoice } = await API.get(apiEndpoint);
    //    //console.log("Returned Invoice : ", returnedInvoice);
    if (returnedInvoice.status === "draft")
      /*const {data:post} =*/ await API.delete(apiEndpoint);
    else {
      apiEndpoint = `/invoices/void/${invoice}`;
      /*const {data:post} =*/ await API.put(apiEndpoint);
    }

    return null;
  };

  deletePayment = async (request) => {
    const apiEndpoint = "/installerPayments/" + request;
    await API.delete(apiEndpoint);
    ////console.log(post);
    return null;
  };

  checkPaymentIntent = async () => {
    //          //console.log( "CreatePaymentIntent: This is the request ID for checking: ", this.state.selectedRequestimate.requestId);
    let paymentCheck = `/installerPaymentsRequest/${this.state.selectedRequestimate.requestId}`;
    //          //console.log ("CreatePaymentIntent : route " ,paymentCheck);
    const { data: intentData } = await API.get(paymentCheck);
    //          //console.log("Call is MADE");
    //          //console.log ("CreatePaymentIntent : Returned installer payment data:" ,intentData)
    return intentData;
  };

  updateInstallerPayment = async (request, paymentRequest) => {
    //        //console.log ("Here's the update records", request, paymentRequest);
    let newPay = {
      payment_id: paymentRequest,
    };
    let paymentUpdate = `/installerPaymentCheck/${request}`;
    await API.put(paymentUpdate, newPay);
  };

createSwipe = async () => {
  try {
    //console.log("createSwipe: Starting payment intent creation");
    //console.log("createSwipe: Invoice:", this.state.invoice);
    //console.log("createSwipe: Installer:", this.state.installer);
    
    if (!this.state.invoice || !this.state.invoice.id) {
      throw new Error("No invoice available for payment");
    }
    
    if (!this.state.installer.stripe_location) {
      throw new Error("No card reader configured");
    }
    
    // Check if payment intent already exists
    let PI = await this.checkPaymentIntent();
    //console.log("createSwipe: Existing payment intent check:", PI);
    
    if (!PI[0] || !PI[0].payment_id) {
      //console.log("createSwipe: Creating new payment intent");
      
      let newSwipe = {
        invoiceId: this.state.invoice.id,
        locationId: this.state.installer.stripe_location,
        installerName: this.state.installer.name,
      };
      
      //console.log("createSwipe: Creating payment with data:", newSwipe);
      
      let paymentRequest = `/payments`;
      const { data: paymentResponse } = await API.post(paymentRequest, newSwipe);
      
      //console.log("createSwipe: Payment response:", paymentResponse);
      
      // FIXED: Handle the new response structure
      if (!paymentResponse.success) {
        throw new Error(paymentResponse.error || 'Failed to create payment intent');
      }
      
      const paymentIntentId = paymentResponse.paymentIntentId || paymentResponse.id;
      
      if (!paymentIntentId) {
        throw new Error('No payment intent ID returned');
      }
      
      //console.log("createSwipe: Payment intent created:", paymentIntentId);
      this.setState({ paymentIntentId });
      
      // Update the installer Payment table
      await this.updateInstallerPayment(
        this.state.selectedRequestimate.requestId,
        paymentIntentId
      );
    } else {
      //console.log("createSwipe: Using existing payment intent:", PI[0].payment_id);
      this.setState({ paymentIntentId: PI[0].payment_id });
    }
    
    //console.log("createSwipe: Final payment intent ID:", this.state.paymentIntentId);
    
  } catch (error) {
    console.error("createSwipe: Error creating payment intent:", error);
    throw error;
  }
};

// NEW: Add missing checkTerminal function (if not exists)
checkTerminal = async (terminalId) => {
  try {
    //console.log("Checking terminal:", terminalId);
    
    const { data: response } = await API.get(`/terminal/${terminalId}`);
    //console.log("Terminal status response:", response);
    
    // FIXED: Validate response structure
    if (!response.success) {
      throw new Error(response.error || 'Failed to get terminal status');
    }
    
    if (response.data && response.data.status === "online") {
      this.setState({ terminalState: "Online" });
      return { status: "online", data: response.data };
    } else {
      this.setState({ terminalState: "Offline" });
      return { status: "offline", data: response.data };
    }
    
  } catch (error) {
    console.error("Terminal check error:", error);
    this.setState({ terminalState: "Offline" });
    throw new Error(`Failed to connect to card reader: ${error.message}`);
  }
};

// NEW: Add missing collectPayment function (if not exists)
collectPayment = async () => {
  try {
    //console.log("collectPayment: Starting collection");
    //console.log("collectPayment: Payment ID:", this.state.paymentIntentId);
    //console.log("collectPayment: Terminal ID:", this.state.installer.stripe_location);
    
    if (!this.state.paymentIntentId) {
      throw new Error("No payment ID provided");
    }
    
    if (!this.state.installer.stripe_location) {
      throw new Error("No terminal configured");
    }
    
    let newPayment = {
      paymentId: this.state.paymentIntentId,
      terminalId: this.state.installer.stripe_location,
    };

    //console.log("collectPayment: Sending to terminal:", newPayment);
    
    let paymentCollect = `/terminalPay/`;
    const { data: response } = await API.post(paymentCollect, newPayment);
    
    //console.log("collectPayment: Terminal response:", response);
    
    // FIXED: Validate response structure
    if (!response.success) {
      throw new Error(response.error || 'Failed to send payment to terminal');
    }
    
    return response;
    
  } catch (error) {
    console.error("collectPayment: Error:", error);
    throw error;
  }
};


  sendMessage = async (data) => {
    //console.log("Requestimates : SendMessage :", data);
    await API.post("/messages/push", data);
    return null;
  };

  // functions to handle the state changes and selections

// Updated sendEmail method for requestimates.jsx
// Replace the existing sendEmail method with this enhanced version

sendEmail = async (request) => {
 //console.log("📧 FRONTEND: Initiating booking email send for request:", request);
  console.time(`📧 Frontend Email Send - ${request}`);
  
  try {
    const response = await API.get(`/sendemailb/${request}`);
    console.timeEnd(`📧 Frontend Email Send - ${request}`);
    
   //console.log("📧 FRONTEND: Email API response:", response.data);
    
    if (response.data && response.data.success) {
     //console.log("✅ FRONTEND: Booking email sent successfully for request:", request);
      return true;
    } else if (response.status === 200 && !response.data.success) {
      // Handle legacy success response (HTTP 200 but no JSON success flag)
     //console.log("✅ FRONTEND: Booking email sent (legacy response) for request:", request);
      return true;
    } else {
      console.warn("⚠️ FRONTEND: Email may not have been sent properly:", {
        request: request,
        response: response.data,
        status: response.status
      });
      return false;
    }
  } catch (error) {
    console.timeEnd(`📧 Frontend Email Send - ${request}`);
    console.error("❌ FRONTEND: Failed to send booking email:", {
      request: request,
      error: error.message,
      status: error.response?.status,
      data: error.response?.data,
      stack: error.stack
    });
    
    // Don't throw - this shouldn't block the booking process
    // But inform the user there might be an issue
    return false;
  }
};

// ADD these methods to the Requestimates class in requestimates.jsx
// Place them after your existing database update methods (around line 500-600)

/**
 * Updates referral status when linked requests progress through workflow stages
 * Uses referral_id from state (loaded during request selection) - no additional API calls needed
 */
updateReferralStatusFromRequest = async (requestState) => {
  try {
    // Add this check in updateReferralStatusFromRequest:
console.log('Selected requestimate:', this.state.selectedRequestimate);
console.log('Referral ID:', this.state.selectedRequestimate.referral_id);
    // Check if this request has a linked referral (from state)
    if (!this.state.selectedRequestimate?.referral_id) {
      // No linked referral - silent return
      return;
    }
    
    // Map request state to referral status
    const referralStatus = this.mapRequestStateToReferralStatus(requestState);
    
    if (!referralStatus) {
      // No mapping needed for this state - silent return
      return;
    }
    
    // Update referral status silently
    // In updateReferralStatusFromRequest method, add:
console.log('Sending referral update:', {
  referral_id: this.state.selectedRequestimate.referral_id,
  status: referralStatus,
  updated_date: new Date().toISOString()
});
    
    await API.put('/referrals', {
      referral_id: this.state.selectedRequestimate.referral_id,
      status: referralStatus,
      updated_date: new Date().toISOString()
    });
    
    // Optional: Log successful update for debugging
    console.log(`Referral status updated: ${this.state.selectedRequestimate.referral_id} → ${referralStatus}`);
    
  } catch (error) {
    // Silent failure - log but don't disrupt main workflow
    console.log('Referral status update skipped:', error.message);
  }
};

/**
 * Maps request states to appropriate referral statuses
 */
mapRequestStateToReferralStatus = (requestState) => {
  const stateMapping = {
    'scheduled': 'BOOKED',
    'received': 'RECEIVED',
    'started': 'STARTED',
    'finished': 'FINISHED',
    'collected': 'COMPLETE'
  };

  return stateMapping[requestState] || null;
};

// REPLACE the handleAcceptEstimate method in requestimates.jsx

handleAcceptEstimate = async (request, startDate) => {
  console.log("Starting job booking process for request:", request.requestId);
  console.log("User selected start date:", startDate);
  
  const jobDuration = parseInt(request.requestDuration) || 1;
  const calculatedEndDate = moment(startDate).add(jobDuration - 1, 'days');
  
  console.log("Job duration:", jobDuration, "days");
  console.log("Calculated end date:", calculatedEndDate.format("YYYY-MM-DD"));
  
  const updatedRequestimate = request;
  const offer = {
    requestId: request.requestId,
    installerId: parseInt(this.state.typeId),
    currentStatus: "scheduled",
    startDate: convertToUTC(startDate).format("YYYY-MM-DD HH:mm:ss"),
    endDate: convertToUTC(calculatedEndDate).format("YYYY-MM-DD HH:mm:ss"),
    dateUpdated: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    location_id: request.location_id || this.props.selectedLocationId || 0,
  };

  updatedRequestimate.currentState = "scheduled";
  // availableDate/dueDate are the customer's original requested dates — don't overwrite
  // Scheduled work dates live on request_offered (startDate/endDate)

  try {
    // Core job booking (always succeeds)
    await this.updateRequest(updatedRequestimate);
    await this.updateRequestOffered(offer);
    await this.updateInstallerCalendar(offer, null, "booked");
    await this.addRequestState(request.requestId, offer.currentStatus, null);

    // Update referral status if this came from a referral
    await this.updateReferralStatusFromRequest('scheduled');

    // Handle deposit invoice creation
    if (updatedRequestimate.deposit_amount && updatedRequestimate.deposit_amount > 0) {
      try {
        await this.handleCreateDepositInvoice(updatedRequestimate);
      } catch (depositError) {
        console.error('Deposit invoice error:', depositError);
      }
    }

    // Calendar sync - try to update existing event first, fall back to create
    if (this.state.authenticated === 1) {
      try {
        // Check if this was a reschedule by looking for existing calendar entry with event_id
        let readAppt = `/readAppt/${request.requestId}`;
        const { data: apptData } = await API.get(readAppt);

        const hasExistingEvent = apptData && apptData.length > 0 && apptData[0].event_id;

        if (hasExistingEvent) {
          // Update existing calendar event (reschedule flow)
          console.log('Updating existing calendar event for reschedule');
          await this.updateAppointment(request.requestId, startDate, calculatedEndDate);
          console.log('Calendar event updated successfully');
        } else {
          // Create new calendar event (first-time booking)
          console.log('Creating new calendar event for first booking');
          await this.addAppointmentSilently(request.requestId);
          console.log('Calendar event created successfully');
        }
      } catch (calendarError) {
        console.error('Calendar sync error:', calendarError);
        // Show warning but don't block the booking
        alert('Job booked successfully, but calendar sync had an issue. You may need to manually update your Google Calendar.');
      }
    }

    await this.clearRequestimate();
    
    ReactGA.event({
      category: "Installer",
      action: "Booked Estimate",
      label: "prod",
    });
    
    let successMessage = "Job booked successfully!";
    if (updatedRequestimate.deposit_amount > 0) {
      successMessage += ` Deposit invoice for $${updatedRequestimate.deposit_amount} created.`;
    }
    
    alert(successMessage);

    // Send email (also silent)
    try {
      await this.sendEmail(request.requestId);
    } catch (emailError) {
      console.log('Email notification skipped');
    }

    window.location = "/jobs?filter=scheduled";
    
  } catch (error) {
    console.error('Error booking job:', error);
    alert('Error booking job. Please try again.');
  }
};

// Quote/Estimate handlers
handleSendQuote = async (request) => {
  try {
    // Handle both camelCase and snake_case field names from API
    const quoteSentAt = request.quoteSentAt || request.quote_sent_at;
    const isResend = quoteSentAt ? true : false;

    if (isResend) {
      const confirmResend = window.confirm(
        `Estimate was already sent on ${moment(quoteSentAt).format("MMM D, YYYY")}. Send again with current pricing?`
      );
      if (!confirmResend) return;
    }

    await API.post(`/requests/${request.requestId}/send-quote`);

    // Add request state record for estimate sent/resent
    await this.addRequestState(
      request.requestId,
      isResend ? "estimate_resent" : "estimate_sent",
      null
    );

    alert(isResend ? "Estimate resent to customer!" : "Estimate sent to customer!");

    ReactGA.event({
      category: "Installer",
      action: isResend ? "Resent Estimate" : "Sent Estimate",
      label: "prod",
    });

    // Refresh to show updated quote status
    window.location.reload();

  } catch (error) {
    console.error('Error sending estimate:', error);
    alert('Error sending estimate. Please try again.');
  }
};

handleDownloadQuotePdf = async (request) => {
  try {
    const { data } = await API.get(`/requests/${request.requestId}/quote-pdf`);

    if (data.url) {
      window.open(data.url, '_blank');
    } else {
      alert('PDF not available at this time.');
    }
  } catch (error) {
    console.error('Error downloading estimate PDF:', error);
    alert('PDF not available at this time.');
  }
};

// 5. ADD: Helper method to create invoices explicitly when needed
createInvoiceExplicitly = async (requestId, requestType, context = 'manual') => {
  try {
    // Check if Stripe capabilities are active
    if (!this.validateStripeCapabilities()) throw new Error('Missing Stripe capabilities');

    console.log(`EXPLICIT: Creating invoice for ${context} - request:`, requestId);
    
    const invoice = {
      invoiceId: requestId,
      invoiceType: requestType,
    };
    
    const apiEndpoint = `/invoices/`;
    const { data: invoiceId } = await API.post(apiEndpoint, invoice);
    console.log(`EXPLICIT: Invoice created successfully for ${context}:`, invoiceId);
    
    return invoiceId;
    
  } catch (invoiceError) {
    console.error(`EXPLICIT: Invoice creation failed for ${context}:`, invoiceError);
    throw invoiceError;
  }
};

// 6. SAFETY CHECK: Add invoice creation validation
validateInvoiceCreation = (request) => {
  if (!request || !request.requestId) {
    throw new Error('Invalid request - missing requestId');
  }
  
  if (!request.requestType) {
    throw new Error('Invalid request - missing requestType');
  }
  
  if (request.currentState !== 'finished') {
    console.warn(`Creating invoice for request in state: ${request.currentState}`);
  }
  
  return true;
};

// Stripe capability validation - now deferred to server-side (decision #7)
// Server returns 400/403 if capabilities are insufficient
validateStripeCapabilities = () => {
  return true;
};

// 7. OPTIONAL: Add method to retry failed invoice creation
retryInvoiceCreation = async (requestId, requestType) => {
  try {
    console.log('RETRY: Attempting to create invoice for request:', requestId);
    
    // Check if invoice already exists
    const existingInvoiceCheck = await API.get(`/requestimates/requestbyID/?Id=${requestId}`);
    const requestData = existingInvoiceCheck.data;
    
    if (requestData && requestData.invoiceId) {
      console.log('RETRY: Invoice already exists:', requestData.invoiceId);
      return requestData.invoiceId;
    }
    
    // Create new invoice
    const invoiceId = await this.createInvoiceExplicitly(requestId, requestType, 'retry');
    
    // Update the request record
    if (invoiceId) {
      const updateData = { ...requestData, invoiceId };
      await this.updateRequest(updateData);
    }
    
    return invoiceId;
    
  } catch (error) {
    console.error('RETRY: Invoice creation failed:', error);
    throw error;
  }
};

// ADD: Silent calendar sync method
addAppointmentSilently = async (requestId) => {
    try {
        let readAppt = `/readAppt/${requestId}`;
        const { data: appt } = await API.get(readAppt);

        let newAppt = {
            request: requestId,
            summary: `${appt[0].Year} ${appt[0].Make} ${appt[0].Model}`,
            description: `Customer: ${this.state.selectedRequestimate.dealerName}`,
            calendar: appt[0].calendar_id,
            startDate: appt[0].work_date,
            duration: appt[0].request_duration,
            installerId: this.props.typeId,
        };

        let apptAdd = `/addAppt/`;
        const response = await API.put(apptAdd, newAppt);
        return response.data;

    } catch (error) {
        // Silent failure - just log
       //console.log('Calendar sync failed silently:', error.message);
        return null;
    }
};

// NEW: Update appointment in Google Calendar (proper reschedule)
updateAppointment = async (requestId, startDate, endDate) => {
    try {
        const payload = {
            requestId: requestId,
            installerId: this.props.typeId,
            startDate: convertToUTC(startDate).format("YYYY-MM-DD HH:mm:ss"),
            endDate: endDate ? convertToUTC(endDate).format("YYYY-MM-DD HH:mm:ss") : null
        };

        let apptUpdate = `/updAppt/`;
        const response = await API.post(apptUpdate, payload);
        return response.data;

    } catch (error) {
        console.error('Calendar update failed:', error);
        throw error; // Re-throw so caller can handle
    }
};

  handlePageChange = async (pageNumber) => {
    //  //console.log(`active page is ${pageNumber}`);
    //  //console.log('selected service :', this.state.selectedService);
    this.setState({ activePage: pageNumber });
  };

handlePaymentChange = async (e) => {
  let selectedPay = e.currentTarget.value;
  //console.log("Selected Pay method is:", selectedPay);

  // Clear check number when switching away from Check payment
  if (selectedPay !== "Check") {
    this.setState({ checkNumber: "" });
  }

  // FIX: Properly await payment intent creation for swipe cards
  if (selectedPay === "Swipe Card") {
    //console.log("Creating payment intent...");
    try {
      await this.createSwipe(); // ✅ Now properly awaited
      //console.log("Payment intent created:", this.state.paymentIntentId);
    } catch (error) {
      console.error("Failed to create payment intent:", error);
      alert("Failed to set up card payment. Please try again.");
      return; // Don't set the payment method if creation failed
    }
  }
  this.setState({ selectedPay });
};

handleCheckNumberChange = (e) => {
  this.setState({ checkNumber: e.currentTarget.value });
};

  handleReviewChange = async (reviewScore) => {
    this.setState({ reviewScore });
  };

  handleTerminal = async (mode) => {
    this.setState({ terminalState: mode });
  };

  // REPLACE the existing handlePickStartDate method in requestimates.jsx

handlePickStartDate = async (startDate) => {
 //console.log("🔥 User selected date:", startDate);
  
  // Prevent unnecessary updates if date hasn't actually changed
  const currentDateStr = moment(this.state.startDate).format("YYYY-MM-DD");
  const newDateStr = moment(startDate).format("YYYY-MM-DD");
  
  if (currentDateStr === newDateStr) {
   //console.log("🔥 Date unchanged, skipping update");
    return;
  }
  
  // SIMPLE: Always use what the user selected
  this.setState({ startDate });
  
  // Optional: Refresh availability info for display purposes only
  // This updates the AvailabilityAlert but doesn't override user choice
  if (this.state.selectedRequestimate && this.state.selectedRequestimate.requestId) {
   //console.log("🔥 Refreshing availability info for context");
    
    // Use a debounced approach to prevent rapid API calls
    if (this.availabilityTimeout) {
      clearTimeout(this.availabilityTimeout);
    }
    
    this.availabilityTimeout = setTimeout(async () => {
      try {
        await this.fetchAvailabilityForRequest(
          this.state.selectedRequestimate.requestId, 
          startDate
        );
      } catch (error) {
       //console.log('Availability refresh failed:', error.message);
      }
    }, 300); // 300ms debounce
  }
  
 //console.log("🔥 Date selection complete:", startDate);
};

// REPLACE the existing fetchAvailabilityForRequest method in requestimates.jsx

fetchAvailabilityForRequest = async (requestId, checkDate) => {
  try {
   //console.log("Fetching availability for request:", requestId, "on date:", checkDate);
    
    // Prevent fetching if already in progress
    if (this.availabilityFetching) {
     //console.log("Availability fetch already in progress, skipping");
      return;
    }
    
    this.availabilityFetching = true;
    
    const dateParam = moment(checkDate).format('YYYY-MM-DD');
    // Use the request's own location, not the nav selector
    const reqLocId = this.state.selectedRequestimate?.location_id || this.state.selectedRequestimate?.locationId;
    const availLocParam = reqLocId && reqLocId !== 0 && reqLocId !== '0'
      ? `&locationId=${reqLocId}` : '';
    const { data: availability } = await API.get(
      `/availability/${this.state.typeId}/${requestId}?checkDate=${dateParam}${availLocParam}`
    );
    
   //console.log("Updated availability for date:", availability);
    
    // Only update state if the request is still the selected one
    if (this.state.selectedRequestimate?.requestId === requestId) {
      this.setState({ availability });
    } else {
     //console.log("Request changed during availability fetch, discarding result");
    }
    
  } catch (error) {
    console.error('Failed to fetch availability for date:', error);
    // Optionally show user feedback
   //console.log('Using fallback availability calculation');
  } finally {
    this.availabilityFetching = false;
  }
};
  handleCloseSwipe = async () => {
  // FIX: Clear polling interval
  if (this.state.paymentPollInterval) {
    console.log("Closing swipe modal - clearing polling interval");
    clearInterval(this.state.paymentPollInterval);
  }

  // FIX: Clear polling timeout
  if (this.pollTimeout) {
    clearTimeout(this.pollTimeout);
  }

  // FIX: Reset invoice settlement flag
  this.invoiceSettled = false;

  this.setState({
    showSwipe: false,
    paymentState: "idle",
    paymentError: null,
    paymentPollInterval: null,
    showCalendar: false  // Keep existing functionality
  });
};
// NEW: Add retry handler
handleRetryPayment = async () => {
  //console.log("Retrying payment...");
  await this.handleSwipeCardFlow();
};

// Cancel terminal payment (stops reader, keeps PaymentIntent for retry)
handleCancelTerminal = async () => {
  try {
    // Cancel the terminal reader action
    if (this.state.installer?.stripe_location) {
      await API.post(`/terminal/${this.state.installer.stripe_location}/cancel`);
    }
  } catch (err) {
    console.error("Cancel terminal failed:", err);
    // Continue to close modal even if cancel fails
  }

  // Close the modal
  this.handleCloseSwipe();
};

  handleClosePO = async () => {
    this.setState({ showPO: false });
  };

  handleShowHelpVideo = () => {
    this.setState({ showHelpVideo: true });
  };

  handleCloseHelpVideo = () => {
    this.setState({ showHelpVideo: false });
  };

  handleVINChange = async (e) => {
    const newVin = e.currentTarget.value;
    let vin = newVin.trim().toUpperCase();
    let vinGood = false;
    //    //console.log('VIN Length :', vin.length);
    let good = vin.match(/[A-HJ-NPR-Z0-9|a-hj-npr-z0-9]{17}/);
    if (vin.length === 17 && good !== null) {
      // for a dealer car, the numbers just have to match
      // because we have already hit the NHSTA database to create the work
      //   if(this.state.selectedRequestimate.requestType === "dealer") {
      //     if(this.state.selectedRequestimate.vin === vin){
      //       vinGood = true
      //     }
      //   } else {
      // for a installer car, hit the NHSTA database to retrieve the car information
      vinGood = true;
      await this.readVIN(vin);
      /*        VINread.then( () => {
          //console.log("NHTSA record :",this.state.vehicleEntered.ModelYear,);      
          //console.log("NHTSA record :",this.state.vehicleEntered.Make,);      
          //console.log("NHTSA record :",this.state.vehicleEntered.Model,);      
          //console.log("Vehicle on file :", this.state.selectedRequestimate.vehicleYear);
          //console.log("Vehicle on file :", this.state.selectedRequestimate.vehicleMake);
          //console.log("Vehicle on file :", this.state.selectedRequestimate.vehicleModel);
        })*/
      // need to handle the case where this isn't available
      //   }
    }
    this.setState({ vin, vinGood });
  };

  handleMaterialsChange = async (e) => {
    const materials = e.currentTarget.value;
    this.setState({ materials });
  };

  handleTemplateChange = async (e) => {
    const template = e.currentTarget.value;
    this.setState({ template });
  };

  handleNameChange = async (e) => {
    const customerName = e.currentTarget.value;
    this.setState({ customerName });
  };

  handleEmailChange = async (e) => {
    const customerEmail = e.currentTarget.value;
    this.setState({ customerEmail });
  };

  handlePhoneChange = async (e) => {
    const customerPhone = e.currentTarget.value;
    this.setState({ customerPhone });
  };

  handleDelete = async (request) => {
    // Show modal to determine if this is a simple delete or a business loss
    this.setState({
      showDeleteOrLossModal: true,
      requestToDelete: request
    });
  };

  handleDeleteConfirm = async (result) => {
    // Close modal
    this.setState({ showDeleteOrLossModal: false });

    const request = this.state.requestToDelete;

    if (!result.confirmed || !request) {
      this.setState({ requestToDelete: null });
      return;
    }

    // Check if this request has a paid deposit
    if (request.depositAmount > 0 && request.depositIsPaid === 1) {
      try {
        const paymentsRes = await API.get(`/installerPaymentsRequest/${request.requestId}`);
        const payments = paymentsRes.data;
        const depositPayment = payments.find(p =>
          p.payment_type === 'deposit' && p.payment_status === 'paid' && p.payment_intent_id
        );

        if (depositPayment) {
          // Show refund modal, store the delete result for after refund decision
          this.setState({
            showDepositRefundModal: true,
            depositRefundPayment: depositPayment,
            deleteConfirmResult: result
          });
          return;
        }
      } catch (err) {
        console.error('Could not fetch deposit payments, proceeding with delete:', err);
        // Graceful degradation — proceed without refund modal
      }
    }

    // No deposit or couldn't fetch — proceed directly
    this.executeDelete(request, result);
  };

  handleRefundDecision = async (refundDecision) => {
    const { depositRefundPayment, deleteConfirmResult, requestToDelete } = this.state;

    // Close refund modal
    this.setState({
      showDepositRefundModal: false,
      depositRefundPayment: null
    });

    // Process refund if requested
    if (!refundDecision.skipRefund && depositRefundPayment) {
      try {
        await API.post('/refunds/deposit', {
          requestId: requestToDelete.requestId,
          paymentIntentId: depositRefundPayment.payment_intent_id,
          refundAmount: refundDecision.refundAmount,
          refundType: refundDecision.refundType,
          reason: 'requested_by_customer'
        });
      } catch (err) {
        const errorMsg = err.response?.data?.error || 'Refund processing failed';
        const proceed = window.confirm(
          `Refund failed: ${errorMsg}\n\nDo you want to proceed with cancellation without a refund?`
        );
        if (!proceed) {
          // Abort entire deletion
          this.setState({ deleteConfirmResult: null, requestToDelete: null });
          return;
        }
      }
    }

    // Continue with deletion
    this.executeDelete(requestToDelete, deleteConfirmResult);
    this.setState({ deleteConfirmResult: null });
  };

  handleRefundCancel = () => {
    // Abort entire deletion
    this.setState({
      showDepositRefundModal: false,
      depositRefundPayment: null,
      deleteConfirmResult: null,
      requestToDelete: null
    });
  };

  executeDelete = async (request, result) => {
    // Determine redirect path
    let redirect = "reqs";
    if (request.currentState === "scheduled") {
      redirect = "jobs";
    }

    // Determine the status to record based on user's choice
    const requestStatus = result.isLoss ? "LOSS" : "deleted";

    const offer = {
      requestId: request.requestId,
      installerId: parseInt(this.state.typeId),
      currentStatus: requestStatus,
      startDate: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      dateUpdated: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    };

    // Update the database
    const updatedRequestimate = request;
    updatedRequestimate.currentState = requestStatus;
    // Update the request state
    await this.updateRequest(updatedRequestimate);

    // Delete the installer calendar entries if already created
    if (this.state.authenticated === 1) {
      try {
        await this.delAppointmentSilently(request.requestId);
        console.log('Calendar event deleted successfully');
      } catch (calendarError) {
        console.error('Failed to delete calendar event:', calendarError);
        // Continue with deletion but note the issue
      }
    }
    await this.deleteInstallerCalendar(offer);

    this.deletePayment(request.requestId);

    // If installer deletes then remove the invoice from Stripe
    if (request.invoiceId) {
      this.deleteInvoice(request.invoiceId);
    }
    await this.updateRequestOffered(offer);

    // Add an audit record to the table WITH REASON
    await this.addRequestState(
      request.requestId,
      requestStatus,
      null,
      result.reasonCode,
      result.reasonNotes
    );

    await this.clearRequestimate();

    if (this.state.userType === "dealer") {
      ReactGA.event({
        category: "Dealer",
        action: result.isLoss ? "Lost Request" : "Deleted Request",
        label: "prod",
      });
      if (result.isLoss) {
        alert("Loss has been recorded for analysis. Installers will be notified that this job is no longer available.");
      } else {
        alert("We'll let the installers who were offered the job that it is no longer available");
      }
    } else {
      if (request.requestType === "installer") {
        ReactGA.event({
          category: "Installer",
          action: result.isLoss ? "Lost Estimate" : "Deleted Estimate",
          label: "prod",
        });
        alert("We've removed the work from your calendar");
      } else {
        ReactGA.event({
          category: "Installer",
          action: "Dealer Incorrect Delivery",
          label: "prod",
        });
        alert("Contact the dealer to let them know they have sent the wrong car");
      }
    }

    // Clear the request to delete
    this.setState({ requestToDelete: null });

    if (redirect === "reqs") {
      window.location = "/requestimates";
    } else {
      window.location = "/jobs?filter=scheduled";
    }
  };

delAppointmentSilently = async (requestId) => {
    try {
        // Use the new request-based approach which handles multi-day events better
        let newAppt = {
            requestId: requestId,
            installerId: this.props.typeId,
        };

        let apptDel = `/delAppt/`;
        const response = await API.put(apptDel, newAppt);
       //console.log('Calendar cleanup completed as bonus');
        return response.data;
        
    } catch (error) {
        // Silent failure - just log
       //console.log('Calendar cleanup failed silently:', error.message);
        return null;
    }
};


  iconState = (state, type) => {
    if (state === "new" && type === "installer") {
      return <i className="fa-sharp fa-solid fa-credit-card"></i>;
    } else {
      switch (state) {
        case "new":
          return <i className="fa-sharp fa-solid fa-comment"></i>;
        case "answered":
          return <i className="fa-sharp fa-solid fa-bell"></i>;
        case "scheduled":
          return <i className="fa-sharp fa-solid fa-calendar"></i>;
        case "received":
          return <i className="fa-sharp fa-solid fa-battery-empty"></i>;
        case "started":
          return <i className="fa-sharp fa-solid fa-battery-half"></i>;
        case "finished":
          return <i className="fa-sharp fa-solid fa-car"></i>;
        case "paid":
          return <i className="fa-sharp fa-solid fa-car"></i>;
        case "collected":
          return <i className="fa-sharp fa-regular fa-star"></i>;
        default:
          break;
      }
    }
  };

  // Get the appropriate date to display in the list based on mode
  // - Estimates (requests): show original availableDate (customer's requested date)
  // - Jobs: show scheduledStart from request_offered (actual booked date)
  // - Pickups: show scheduledEnd from request_offered (expected completion date)
  getDisplayDate = (item, mode) => {
    // For estimates, show original requested date
    if (mode === "requests") {
      return convertFromUTC(item.availableDate);
    }

    // For pickups (finished jobs), show the scheduled end date
    if (mode === "pickups" || item.currentState === "finished") {
      return item.scheduledEnd ? moment(item.scheduledEnd) : convertFromUTC(item.dueDate);
    }

    // For jobs, show the scheduled start date
    return item.scheduledStart ? moment(item.scheduledStart) : convertFromUTC(item.availableDate);
  };

  // Sort a list of requests by their scheduled date (from request_offered)
  sortByCalendarDate = (requestList) => {
    return requestList.sort((a, b) => {
      const dateA = a.scheduledStart ? moment(a.scheduledStart) : moment(a.availableDate);
      const dateB = b.scheduledStart ? moment(b.scheduledStart) : moment(b.availableDate);

      return dateA.diff(dateB);
    });
  };

  handleCancel = async () => {
    this.setState({ selectedService: 0, hiddenList: false });
    await this.clearRequestimate();
  };

  acceptCard = async () => {
    this.setState({ showSwipe: true });
  };

  handlePurchaseOrder = async () => {
    this.setState({ showPO: true });
  };

  handleSwipe = async () => {
    this.setState({ showSwipe: false });
  };

  isDiscoveryJob = (request) => {
  return request.assignedTo === 0;
  }


// ALSO REPLACE the handleDiscoveryAutoAssign method in requestimates.jsx

handleDiscoveryAutoAssign = async (request, startDate) => {
 //console.log("CLAIM clicked - startDate parameter:", startDate);
 //console.log("CLAIM clicked - this.state.startDate:", this.state.startDate);
 //console.log("CLAIM clicked - date picker should show:", moment(startDate).format("YYYY-MM-DD"));
  
  try {
    // CALCULATE END DATE BASED ON NEW START DATE
    const jobDuration = parseInt(request.requestDuration) || 1;
    const calculatedEndDate = moment(startDate).add(jobDuration - 1, 'days');
    
   //console.log("Discovery job duration:", jobDuration, "days");
   //console.log("Discovery calculated end date:", calculatedEndDate.format("YYYY-MM-DD"));
    
    const claimData = {
      installerId: this.state.typeId,
      startDate: convertToUTC(startDate).format("YYYY-MM-DD HH:mm:ss"),
      endDate: convertToUTC(calculatedEndDate).format("YYYY-MM-DD HH:mm:ss"),
      location_id: this.props.selectedLocationId || null
    };
    
    await API.post(`/dashboard/claim/${request.requestId}`, claimData);

    alert("Discovery job claimed and booked successfully!");
    await this.clearRequestimate();
    window.location = "/jobs?filter=scheduled"; // Now scheduled work
    
  } catch (error) {
    if (error.response?.status === 409) {
      alert("This job has already been claimed by another specialist.");
    } else {
      alert("Failed to claim job. Please try again.");
    }
  }
}

handleAccept = async (request, startDate) => {
  // Guard: multi-location installer must assign location before claiming
  if (this.requireLocationAssignment(request, () => this.handleAccept(request, startDate))) return;

  if (this.isDiscoveryJob(request)) {
    return this.handleDiscoveryAutoAssign(request, startDate);
  }
  // Fallback for any edge cases
    const updatedRequestimate = request;
    // update the request_offer
    const offer = {
      requestId: request.requestId,
      installerId: parseInt(this.state.typeId),
      currentStatus: "accepted",
      startDate: convertToUTC(startDate).format("YYYY-MM-DD HH:mm:ss"),
      dateUpdated: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    };
    updatedRequestimate.currentState = "answered";
    // update the request to "answered"
    let urequest = await this.updateRequest(updatedRequestimate);

    // if the date has changed, then we need to reschedule the calendar appointments

    if (
      moment(this.state.selectedOffers[0].startDate).format("YYYY-MM-DD") ===
      moment(startDate).format("YYYY-MM-DD")
    ) {
      // update the offer
      await this.updateRequestOffered(offer);

      // update the installer Calendar - All Services for the request
      await this.updateInstallerCalendar(offer, null, "pending");

      // if the user is google authenticated, add the services to their google calendar
    } else {
      // remove the original calendar entries
      await this.deleteInstallerCalendar(offer);
      // call the reschedule module
      await this.updateSchedule(offer, startDate);
    }

    // add an audit record to the table
    let astate = await this.addRequestState(
      request.requestId,
      offer.currentStatus,
      null
    );
    Promise.all([urequest, astate]).then(() => {
      // For dealer jobs, notify the dealer contact person
      const contactId = request.dealerContact || request.dealer_contact || request.requestor;
      let data = {
        messageType: "User",
        messagePlatform: "SMS",
        userType: "dealer",
        id: contactId,
        text: `${this.props.companyName} has responded to your request`,
      };
      this.sendMessage(data);

      ReactGA.event({
        category: "Installer",
        action: "Answered Request",
        label: "prod",
      });
      this.clearRequestimate();
      alert("We'll let them know you are interested");
    });
    window.location = "/requestimates";
  };

handleCompleteEstimate = async (request, startDate) => {
  console.log("Handle Complete Estimate", request, startDate);

  // Check if installer has Stripe account set up
  if (!this.state.installer.stripe_account_id || !this.state.installer.onboarding_complete) {
    alert(
      "⚠️ Payment Account Required\n\n" +
      "You must complete your payment account setup before you can complete jobs.\n\n" +
      "Please click on 'Profile' in the navigation menu (look for the ⚠️ warning icon) to set up your payment account.\n\n" +
      "This is a one-time setup that takes about 3-5 minutes."
    );
    return;
  }

  // Check if Stripe capabilities are active
  if (!this.validateStripeCapabilities()) return;

  // Check for missing/placeholder VIN (installer only)
  if (this.state.userType === 'installer' && !request._vinCheckSkipped) {
    const vinMissing = !request.vin ||
      request.vin.toUpperCase().startsWith('NV') ||
      request.vin.toUpperCase().startsWith('OT');

    if (vinMissing) {
      this.setState({
        showVINRequiredModal: true,
        vinRequiredRequest: request,
        vinRequiredStartDate: startDate
      });
      return;
    }
  }

  const updatedRequestimate = request;
  const offer = {
    requestId: request.requestId,
    installerId: parseInt(this.state.typeId),
    currentStatus: "finished",
    startDate: convertToUTC(startDate).format("YYYY-MM-DD HH:mm:ss"),
    dateUpdated: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
  };
  
  updatedRequestimate.currentState = "finished";
  updatedRequestimate.availableDate = offer.startDate;

  // Remove automatic invoice creation from updateRequest
  await this.updateRequest(updatedRequestimate);

  if (
    moment(this.state.selectedOffers[0].startDate).format("YYYY-MM-DD") ===
    moment(startDate).format("YYYY-MM-DD")
  ) {
    await this.updateRequestOffered(offer);
    await this.updateInstallerCalendar(offer, null, "finished");
  } else {
    await this.deleteInstallerCalendar(offer);
    await this.updateSchedule(offer, startDate);
  }

  await this.addRequestState(
    request.requestId,
    offer.currentStatus,
    null
  );

  // UPDATED: Enhanced invoice creation with failure logging
  try {
    console.log("EXPLICIT: Creating invoice for completed estimate:", request.requestId);
    const invoice = {
      invoiceId: request.requestId,
      invoiceType: request.requestType,
    };
    
    const apiEndpoint = `/invoices/`;
    const { data: invoiceId } = await API.post(apiEndpoint, invoice);
    console.log("EXPLICIT: Invoice created successfully:", invoiceId);
    
    if (invoiceId) {
      updatedRequestimate.invoiceId = invoiceId;
    }
    
  } catch (invoiceError) {
    console.error("EXPLICIT: Invoice creation failed for request", request.requestId, ":", invoiceError);
    
    // NEW: Log the failure for debugging
    await this.logPaymentFailure('invoice_creation', 'handleCompleteEstimate', invoiceError);
    
    alert("Estimate completed successfully, but there was an issue creating the invoice. Please check the invoices section or contact support.");
  }

  await this.clearRequestimate();

  ReactGA.event({
    category: "Installer",
    action: "Completed Work",
    label: "prod",
  });
  alert("Invoice Generated");
  window.location = "/pickups";
};



  handleReschedule = async (request) => {
    console.log("Starting reschedule process for request:", request.requestId);

    const updatedRequestimate = request;
    // Used for a request and an estimate by an installer
    const offer = {
      requestId: request.requestId,
      installerId: parseInt(this.state.typeId),
      currentStatus: "offered",
      startDate: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      dateUpdated: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      location_id: request.location_id || this.props.selectedLocationId || 0,
    };

    try {
      // Update the database - mark as offered
      await this.updateRequestOfferedState(offer);

      // Reset the request to new state (user will pick new date)
      updatedRequestimate.currentState = "new";
      await this.updateRequest(updatedRequestimate);

      // NOTE: We no longer delete the calendar event here!
      // The calendar event will be UPDATED (not deleted) when user picks new date
      // This preserves the event_id so we can properly update it later

      // Update installer calendar to draft status
      await this.updateInstallerCalendar(offer, null, "draft");

      // Track the reschedule in request state
      await this.addRequestState(
        request.requestId,
        "rescheduled",
        null
      );

      ReactGA.event({
        category: "Installer",
        action: "Initiated Reschedule",
        label: "prod",
      });

      alert("Job is reset to estimate for rescheduling. The calendar event will be updated when you select a new date.");
      window.location = "/requestimates";

    } catch (error) {
      console.error('Error during reschedule:', error);
      alert('Error initiating reschedule. Please try again.');
    }
  };

  // DEALER RESCHEDULE FEATURE - Validation method
  canDealerReschedule = (request) => {
    // Only dealers can use this feature
    if (this.state.userType !== 'dealer') {
      return { canReschedule: false, reason: 'Only dealers can reschedule' };
    }

    // Check if job is in an allowed state
    const allowedStates = ['new', 'scheduled', 'received'];
    if (!allowedStates.includes(request.currentState)) {
      return { canReschedule: false, reason: `Cannot reschedule jobs in ${request.currentState} state` };
    }

    // Check if job is starting today (can't reschedule same-day jobs)
    const today = moment().startOf('day');
    const jobStartDate = moment(request.availableDate).startOf('day');

    if (jobStartDate.isSame(today)) {
      return { canReschedule: false, reason: 'Cannot reschedule jobs starting today' };
    }

    return { canReschedule: true };
  };

  // DEALER RESCHEDULE FEATURE - Main handler
  handleDealerReschedule = async (request, newAvailableDate, newDueDate) => {
    console.log("Dealer reschedule: Starting for request:", request.requestId);
    console.log("Dealer reschedule: New available date:", newAvailableDate);
    console.log("Dealer reschedule: New due date:", newDueDate);

    // Validate reschedule is allowed
    const validation = this.canDealerReschedule(request);
    if (!validation.canReschedule) {
      alert(validation.reason);
      return;
    }

    try {
      const updatedRequest = { ...request };

      // Update both dates
      updatedRequest.availableDate = moment(newAvailableDate).format("YYYY-MM-DD HH:mm:ss");
      updatedRequest.dueDate = moment(newDueDate).format("YYYY-MM-DD HH:mm:ss");

      // For NEW requests - simple due date update
      if (request.currentState === 'new') {
        await this.updateRequest(updatedRequest);

        await this.addRequestState(
          request.requestId,
          "dealer_reschedule_minor",
          null,
          "DEADLINE_CHANGE",
          `Schedule updated: Available ${moment(newAvailableDate).format("MM/DD/YYYY")}, Due ${moment(newDueDate).format("MM/DD/YYYY")}. Job not yet claimed.`
        );

        ReactGA.event({
          category: "Dealer",
          action: "Reschedule Unclaimed Job",
          label: "prod",
        });

        alert("Due date updated. Specialists will see the new timeline when claiming jobs.");
        window.location.reload();
        return;
      }

      // For SCHEDULED/RECEIVED jobs - check if existing schedule fits
      const calendarEntries = this.state.calendarDays.filter(
        entry => entry.requestId === request.requestId &&
                 ['booked', 'pending', 'started'].includes(entry.workStatus)
      );

      if (calendarEntries.length === 0) {
        // No schedule found, just update due date
        await this.updateRequest(updatedRequest);

        await this.addRequestState(
          request.requestId,
          "dealer_reschedule_minor",
          null,
          "DEADLINE_CHANGE",
          `Schedule updated: Available ${moment(newAvailableDate).format("MM/DD/YYYY")}, Due ${moment(newDueDate).format("MM/DD/YYYY")}. No active schedule found.`
        );

        alert("Schedule updated successfully.");
        window.location.reload();
        return;
      }

      // Check if current schedule fits within new deadline
      const sortedEntries = _.orderBy(calendarEntries, 'workDate', 'asc');
      const currentScheduledStart = moment(sortedEntries[0].workDate);
      const currentScheduledEnd = moment(sortedEntries[sortedEntries.length - 1].workDate);

      // Calculate original window
      const originalAvailableDate = moment(request.availableDate);
      const newDueDateMoment = moment(newDueDate);

      // Check if schedule fits in new window
      const scheduleFitsInNewWindow =
        currentScheduledStart.isSameOrAfter(originalAvailableDate) &&
        currentScheduledEnd.isSameOrBefore(newDueDateMoment);

      if (scheduleFitsInNewWindow) {
        // Schedule unchanged - minor reschedule
        await this.updateRequest(updatedRequest);

        await this.addRequestState(
          request.requestId,
          "dealer_reschedule_minor",
          null,
          "DEADLINE_CHANGE",
          `Schedule updated: Available ${moment(newAvailableDate).format("MM/DD/YYYY")}, Due ${moment(newDueDate).format("MM/DD/YYYY")}. Existing schedule (${currentScheduledStart.format("MM/DD")} - ${currentScheduledEnd.format("MM/DD")}) unchanged.`
        );

        // TODO: Send SMS notification to specialist about new deadline
        console.log("TODO: Send SMS to specialist about deadline change");

        ReactGA.event({
          category: "Dealer",
          action: "Reschedule Minor (Schedule Unchanged)",
          label: "prod",
        });

        alert("Schedule updated. Specialist's work dates remain unchanged and they've been notified of the new timeline.");
        window.location.reload();
      } else {
        // Schedule conflicts - major reschedule (specialist must re-book)
        await this.updateRequest(updatedRequest);

        // Clear the calendar entries (specialist must re-book)
        const offer = {
          requestId: request.requestId,
          installerId: request.assignedTo,
          currentStatus: "rescheduled",
          startDate: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
          dateUpdated: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        };

        await this.deleteInstallerCalendar(offer);

        // Update request_offered status back to "offered" so installer can re-book
        const updatedOffer = {
          requestId: request.requestId,
          installerId: request.assignedTo,
          currentStatus: "offered",
          dateUpdated: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        };
        await this.updateRequestOffered(updatedOffer);

        // Delete Google Calendar event if exists
        if (this.state.authenticated === 1) {
          try {
            await this.delAppointmentSilently(request.requestId);
          } catch (calendarError) {
            console.error('Failed to delete calendar event:', calendarError);
          }
        }

        // Update request state to 'new' so specialist can re-book
        updatedRequest.currentState = 'new';
        await this.updateRequest(updatedRequest);

        await this.addRequestState(
          request.requestId,
          "dealer_reschedule_major",
          null,
          "SCHEDULE_CONFLICT",
          `Schedule updated: Available ${moment(newAvailableDate).format("MM/DD/YYYY")}, Due ${moment(newDueDate).format("MM/DD/YYYY")}. Previous schedule (${currentScheduledStart.format("MM/DD")} - ${currentScheduledEnd.format("MM/DD")}) cleared. Specialist must re-book.`
        );

        // TODO: Send SMS notification to specialist that they must re-book
        console.log("TODO: Send SMS to specialist - must re-book");

        ReactGA.event({
          category: "Dealer",
          action: "Reschedule Major (Requires Re-booking)",
          label: "prod",
        });

        alert("Schedule updated. The new timeline conflicts with the existing schedule, so it has been cleared. The specialist will need to re-book their work.");
        window.location.reload();
      }

    } catch (error) {
      console.error('Error during dealer reschedule:', error);
      alert('Error rescheduling job. Please try again.');
    }
  };

  handleReject = async (request) => {
    // Show modal for confirmation and reason collection
    this.setState({
      showRejectModal: true,
      requestToReject: request
    });
  };

  handleRejectConfirm = async (result) => {
    // Close modal
    this.setState({ showRejectModal: false });

    const request = this.state.requestToReject;

    if (!result.confirmed || !request) {
      this.setState({ requestToReject: null });
      return;
    }

    // This is for operational tracking (wrong vehicle, installer unavailable, etc.)
    // NOT for business loss tracking - that's handled in handleDelete

    const offer = {
      requestId: request.requestId,
      installerId: parseInt(this.state.typeId),
      currentStatus: "rejected",
      startDate: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      dateUpdated: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    };

    // update the database
    let offered = await this.updateRequestOfferedState(offer);

    // Add request_state tracking for rejections with user-provided reason
    let astate = await this.addRequestState(
      request.requestId,
      "rejected",
      null,
      result.reasonCode,
      result.reasonNotes
    );

    // delete the draft calendar entries
    if (this.state.authenticated === 1) {
      try {
        await this.delAppointmentSilently(request.requestId);
      } catch (calendarError) {
        // Completely silent - no user notification
      }
    }
    // update the installer Calendar
    let calendar = await this.deleteInstallerCalendar(offer);

    Promise.all([offered, calendar, astate]).then(() => {
      if (request.requestType === "dealer") {
        ReactGA.event({
          category: "Installer",
          action: "Rejected Request",
          label: "prod",
        });
        alert("We'll let them know you aren't available");
      } else {
        ReactGA.event({
          category: "Installer",
          action: "Estimate Rejected",
          label: "prod",
        });
        alert("Rejection recorded. The dealer will be notified.");
      }

      // Clear the request to reject
      this.setState({ requestToReject: null });

      this.clearRequestimate();
      window.location = "/requestimates";
    });
  };

  handleSelect = (row) => {
    this.setState({ selectedInstaller: row });
  };

  handleSelectService = (row) => {
    //  //console.log("Selected Service is :", row)
    this.setState({ selectedService: row, rowSelected: true });
  };

  handleSelectInstaller = (row) => {
    //  //console.log("Request : Here's the passed Installer : ", row)
    this.setState({ selectedInstaller: row, rowSelected: true });
  };

  handleAssign = async (request, installer) => {
    // Only used for a request by a dealer
    // set up the rquest

    //  //console.log("Assigning job to installer : ", installer);
    const updatedRequestimate = request;
    updatedRequestimate.currentState = "scheduled";
    updatedRequestimate.assignedTo = this.state.selectedInstaller.installerId;
    // set up the offer
    const offer = {
      requestId: updatedRequestimate.requestId,
      installerId: this.state.selectedInstaller.installerId,
      currentStatus: updatedRequestimate.currentState,
      dateUpdated: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      startDate: convertToUTC(installer.startDate).format(
        "YYYY-MM-DD HH:mm:ss"
      ),
    };
    // update the request
    let urequest = await this.updateRequest(updatedRequestimate);
    //update the request offer
    let uoffered = await this.updateRequestOffered(offer);
    // update the installer Calendar for the specific service
    let ucalendar = await this.updateInstallerCalendar(offer, null, "booked");
    // add an audit record to the table
    let astate = await this.addRequestState(
      request.requestId,
      updatedRequestimate.currentState,
      null
    );
    this.setState({ selectedOffer: {} });
    await this.clearRequestimate();
    Promise.all([urequest, uoffered, ucalendar, astate]).then(() => {
      //    //console.log ("Handle Assign : request : ", request);

      let data = {
        messageType: "User",
        messagePlatform: "SMS",
        userType: "installer",
        id: updatedRequestimate.assignedTo,
        text: `${this.props.companyName} has assigned you a job. https://jobvious.app`,
      };
      this.sendMessage(data);

      ReactGA.event({
        category: "Dealer",
        action: "Assigned Work",
        label: "prod",
      });
      alert("We'll schedule the work with your installer immediately");
      window.location = "/jobs?filter=scheduled";
    });
  };

  handleReceive = async (request, vin) => {
    // Only used for a request by a dealer
    // set up the rquest

    // update the vehicle record for the request VIN
    // if its a duplicate, then drop the NV record
    const updatedRequestimate = request;
    updatedRequestimate.currentState = "received";

    if (vin.length > 0) {
      await this.updateVehicle(request.vin, vin);
      updatedRequestimate.vin = vin;
    }

    // update the request
    let urequest = await this.updateRequest(updatedRequestimate);
    const offer = {
      requestId: updatedRequestimate.requestId,
      installerId: parseInt(this.state.typeId),
      currentStatus: updatedRequestimate.currentState,
      dateUpdated: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    };
    let uoffered = await this.updateRequestOfferedState(offer);

    // Mark customer as owned by installer when vehicle received (WIN moment)
    if (request.requestType === "installer") {
      // Transfer customer ownership from prospect to customer owned by this installer
      await this.updateCustomer(request.requestor);
    }

    // add an audit record to the table - Mark as WIN when vehicle received
    let astate = await this.addRequestState(
      request.requestId,
      updatedRequestimate.currentState,
      null,
      "WIN",  // reasonCode: This is a business win!
      "Vehicle received - customer committed to service"  // reasonNotes
    );
    this.setState({ selectedOffer: {} });
    Promise.all([urequest, uoffered, astate]).then(() => {
      if (updatedRequestimate.requestType === "dealer") {
        // For dealer jobs, notify the dealer contact person
        const contactId = request.dealerContact || request.dealer_contact || request.requestor;
        let data = {
          messageType: "User",
          messagePlatform: "SMS",
          userType: "dealer",
          id: contactId,
          text: `${this.props.companyName} has received your vehicle`,
        };

        this.sendMessage(data);
      }
      window.location = "/jobs?filter=inprogress";
    });
  };

  handleStart = async (request, thisJob, serviceObj) => {
    // Only used for a job by an installer
    // serviceObj is now the full service object from services_ (not just service_id)
    const serviceId = serviceObj.service_id;
    console.log("Handle Start", request, thisJob, serviceObj, "serviceId:", serviceId);

    const requestService = {
      requestServiceId: serviceObj.id,
      requestId: request.requestId,
      serviceId: serviceId,
      serviceState: "started",
      serviceDate: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      materials: this.state.materials,
      template: this.state.template,
    };
    // NOTE: Customer ownership is now transferred when vehicle is RECEIVED (WIN moment)
    // not when work starts. See handleReceive() for customer ownership transfer.

    // update the service
    const calendar = {
      requestId: request.requestId,
      installerId: parseInt(this.state.typeId),
    };
    // update the services on the original request
    await this.updateRequestServices(requestService);

    // update the appointments in the installer's calendar
    await this.updateInstallerCalendar(
      calendar,
      requestService.serviceId,
      "started"
    );

    // log the change on the request in the audit log
    await this.addRequestState(
      requestService.requestId,
      "start",
      serviceId
    );

    // if it's the first service on the job, update the request
    // all the services in thisJob will be "booked"

    if (request.currentState === "received") {
      const updatedRequestimate = request;
      updatedRequestimate.currentState = "started";
      // update the request
      await this.updateRequest(updatedRequestimate);
      // update the offer
      const offer = {
        requestId: updatedRequestimate.requestId,
        installerId: parseInt(this.state.typeId),
        currentStatus: updatedRequestimate.currentState,
        dateUpdated: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      };
      await this.updateRequestOfferedState(offer);

      // add an audit record to the table
      await this.addRequestState(
        requestService.requestId,
        updatedRequestimate.currentState,
        null
      );
      this.setState({ selectedRequestimate: updatedRequestimate });
      //console.log("Handle Start : request : ", request);
      await this.updateReferralStatusFromRequest('started');

      if (request.requestType === "dealer") {
        // For dealer jobs, notify the dealer contact person
        const contactId = request.dealerContact || request.dealer_contact || request.requestor;
        let data = {
          messageType: "User",
          messagePlatform: "SMS",
          userType: "dealer",
          id: contactId,
          text: `${this.props.companyName} has started work on your vehicle`,
        };
        this.sendMessage(data);
      } else {
        // For retail/customer jobs, notify the customer on record
        let data = {
          messageType: "Customer",
          messagePlatform: "SMS",
          userType: "customer",
          id: request.requestor,
          text: `${this.props.companyName} has started work on your vehicle`,
        };
        this.sendMessage(data);
      }
      ReactGA.event({
        category: "Installer",
        action: "Started Job",
        label: "prod",
      });
      alert("We'll let them know you've started the work");
      window.location = "/jobs?filter=inprogress";
    }

    ReactGA.event({ category: "Installer", action: "Started Service" });
    await this.clearRequestimate();

    window.location = "/jobs?filter=inprogress";
  };

  handleFinish = async (request, thisJob, serviceObj) => {
    // serviceObj is now the full service object from services_ (not just service_id)

    // For dealers or if no category configs loaded, skip materials collection
    if (this.state.userType !== 'installer') {
      await this.completeServiceFinish(request, thisJob, serviceObj);
      return;
    }

    if (Object.keys(this.state.categoryConfigs).length === 0) {
      await this.completeServiceFinish(request, thisJob, serviceObj);
      return;
    }

    // Check if this category needs data collection
    const categoryConfig = this.state.categoryConfigs[serviceObj.service_category];

    // Check shop-level materials tracking setting
    const materialsTrackingEnabled = this.props.company?.materials_tracking_enabled !== false;

    // Check if material tasks are already completed (e.g., by technician)
    const tasks = this.state.itemsByServiceId[serviceObj.id] || (serviceObj.items || []);
    const materialTasks = tasks.filter(t => t.type === 'material');
    const allMaterialsDone = materialTasks.length > 0 &&
      materialTasks.every(t => t.status === 'completed' || t.status === 'skipped');

    if (materialsTrackingEnabled && categoryConfig?.data_collect && !allMaterialsDone && materialTasks.length > 0) {
      // Show per-item capture for incomplete material tasks
      const incompleteTasks = materialTasks.filter(t => t.status !== 'completed' && t.status !== 'skipped');
      this.setState({
        showItemCaptureModal: true,
        itemCaptureService: serviceObj,
        itemCaptureItems: incompleteTasks,
        itemCaptureRequest: request,
        itemCaptureJob: thisJob
      });
    } else {
      // No data collection needed (no material tasks, or all already done)
      await this.completeServiceFinish(request, thisJob, serviceObj);
    }
  };

  // Handle per-item material capture completion (from ItemMaterialCaptureModal)
  handleItemCaptureComplete = async () => {
    const { itemCaptureRequest, itemCaptureJob, itemCaptureService } = this.state;
    this.setState({
      showItemCaptureModal: false,
      itemCaptureService: null,
      itemCaptureItems: [],
      itemCaptureRequest: null,
      itemCaptureJob: null
    });
    if (!itemCaptureService) return;

    // Determine if this was a single-service finish or complete-all
    if (Array.isArray(itemCaptureJob)) {
      await this.completeAllServicesFinish(itemCaptureRequest, itemCaptureJob);
    } else {
      await this.completeServiceFinish(itemCaptureRequest, itemCaptureJob, itemCaptureService);
    }
  };

  // VIN verified from VINRequiredModal — resume handleCompleteEstimate
  handleVINVerifiedForComplete = (vin) => {
    const { vinRequiredRequest, vinRequiredStartDate } = this.state;
    vinRequiredRequest.vin = vin;
    this.setState({
      showVINRequiredModal: false,
      vinRequiredRequest: null,
      vinRequiredStartDate: null
    }, () => {
      this.handleCompleteEstimate(vinRequiredRequest, vinRequiredStartDate);
    });
  };

  // User chose to skip VIN entry — proceed with completion as-is
  handleVINSkipForComplete = () => {
    const { vinRequiredRequest, vinRequiredStartDate } = this.state;
    vinRequiredRequest._vinCheckSkipped = true;
    this.setState({
      showVINRequiredModal: false,
      vinRequiredRequest: null,
      vinRequiredStartDate: null
    }, () => {
      this.handleCompleteEstimate(vinRequiredRequest, vinRequiredStartDate);
    });
  };

  // Complete a single service finish (called after materials collection or directly)
  // serviceObj is the full service row object (has .id for row PK and .service_id for master service FK)
  completeServiceFinish = async (request, thisJob, serviceObj, forceComplete = false) => {
    const serviceId = serviceObj.service_id || serviceObj;
    const requestServiceId = serviceObj.id || null;

    const requestService = {
      requestServiceId: requestServiceId,
      requestId: request.requestId,
      serviceId: serviceId,
      serviceState: "finished",
      serviceDate: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss")
    };

    if (forceComplete) {
      requestService.force_complete = true;
    }

    try {
      await this.updateRequestServices(requestService);
    } catch (error) {
      // Check for task completion guard (400 with task_status)
      if (error.response && error.response.status === 400 && error.response.data?.task_status) {
        const taskStatus = error.response.data.task_status;
        this.setState({
          showItemGuardModal: true,
          itemGuardData: {
            serviceName: (serviceObj?.service_category ? `${serviceObj.service_category} - ` : '') + (serviceObj?.description || serviceObj?.custom_description || 'Unknown Service'),
            taskStatus,
            retryCallback: () => {
              this.setState({ showItemGuardModal: false, itemGuardData: null });
              this.completeServiceFinish(request, thisJob, serviceObj, true);
            }
          }
        });
        return;
      }
      throw error;
    }

    // Audit and calendar updates only after successful state change
    await this.addRequestState(
      request.requestId,
      "finish",
      serviceId
    );

    await this.updateInstallerCalendar(
      request,
      serviceId,
      "finished"
    );

    ReactGA.event({
      category: "Installer",
      action: "Finished Service",
      label: "prod",
    });

    await this.clearRequestimate();
    window.location = "/jobs?filter=inprogress";
  };

handleComplete = async (request, servicesArray) => {
  // Check if installer has Stripe account set up
  if (!this.state.installer.stripe_account_id || !this.state.installer.onboarding_complete) {
    alert(
      "⚠️ Payment Account Required\n\n" +
      "You must complete your payment account setup before you can complete jobs.\n\n" +
      "Please click on 'Profile' in the navigation menu (look for the ⚠️ warning icon) to set up your payment account.\n\n" +
      "This is a one-time setup that takes about 3-5 minutes."
    );
    return;
  }

  // Check if Stripe capabilities are active
  if (!this.validateStripeCapabilities()) return;

  // CarFax data guard: For retail (installer-sourced) jobs where CarFax is not opted out,
  // require odometer reading and plate state before completion
  if (request.requestType === 'installer' && !this.state.checkinCarfaxOptOut) {
    const hasOdometer = this.state.checkinOdometerReading && String(this.state.checkinOdometerReading).trim() !== '';
    const hasPlate = this.state.checkinPlate && String(this.state.checkinPlate).trim() !== '';
    if (!hasOdometer || !hasPlate) {
      this.setState({
        showCarFaxDataModal: true,
        carfaxDataRequest: request,
        carfaxDataServicesArray: servicesArray
      });
      return;
    }
  }

  // For dealers or if no category configs loaded, skip materials collection
  if (this.state.userType !== 'installer' || Object.keys(this.state.categoryConfigs).length === 0) {
    await this.completeAllServicesFinish(request, servicesArray);
    return;
  }

  // Find services with incomplete material tasks
  const servicesWithIncompleteTasks = [];
  servicesArray.forEach(service => {
    const categoryConfig = this.state.categoryConfigs[service.service_category];
    if (!categoryConfig?.data_collect) return;

    const tasks = this.state.itemsByServiceId[service.id] || (service.items || []);
    const materialTasks = tasks.filter(t => t.type === 'material');
    const incompleteTasks = materialTasks.filter(t => t.status !== 'completed' && t.status !== 'skipped');

    if (incompleteTasks.length > 0) {
      servicesWithIncompleteTasks.push({ service, incompleteTasks });
    }
  });

  if (servicesWithIncompleteTasks.length > 0) {
    // Show per-item capture for the first service with incomplete tasks
    const first = servicesWithIncompleteTasks[0];
    this.setState({
      showItemCaptureModal: true,
      itemCaptureService: first.service,
      itemCaptureItems: first.incompleteTasks,
      itemCaptureRequest: request,
      itemCaptureJob: servicesArray
    });
  } else {
    // No services need data collection
    await this.completeAllServicesFinish(request, servicesArray);
  }
};

// Handler for when CarFax data is collected via the modal
handleCarFaxDataComplete = (odometerReading, plate) => {
  const { carfaxDataRequest, carfaxDataServicesArray } = this.state;
  this.setState({
    showCarFaxDataModal: false,
    carfaxDataRequest: null,
    carfaxDataServicesArray: null,
    checkinOdometerReading: odometerReading,
    checkinPlate: plate
  }, () => {
    // Resume the completion flow now that data is captured
    if (carfaxDataRequest && carfaxDataServicesArray) {
      this.handleComplete(carfaxDataRequest, carfaxDataServicesArray);
    }
  });
};

// Complete all services finish - actual completion logic
completeAllServicesFinish = async (request, thisJob) => {
  const requestService = {
    requestId: request.requestId,
    serviceState: "finished",
    serviceDate: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
  };

  await this.addRequestState(
    request.requestId,
    "finish",
    null
  );

  try {
    await this.updateRequestAllServices(requestService);
  } catch (error) {
    // Check for task completion guard (400 with task_status)
    if (error.response && error.response.status === 400 && error.response.data?.task_status) {
      const taskStatus = error.response.data.task_status;
      this.setState({
        showItemGuardModal: true,
        itemGuardData: {
          serviceName: 'All Services',
          taskStatus,
          retryCallback: () => {
            this.setState({ showItemGuardModal: false, itemGuardData: null });
            // Retry with force_complete
            const forceService = { ...requestService, force_complete: true };
            this.updateRequestAllServices(forceService).then(() => {
              window.location = "/jobs?filter=inprogress";
            });
          }
        }
      });
      return;
    }
    throw error;
  }

  ReactGA.event({
    category: "Installer",
    action: "Finished Job",
    label: "prod",
  });

  const updatedRequestimate = request;
  updatedRequestimate.currentState = "finished";

  // Remove automatic invoice creation from updateRequest
  await this.updateRequest(updatedRequestimate);

  const offer = {
    requestId: updatedRequestimate.requestId,
    installerId: parseInt(this.state.typeId),
    currentStatus: updatedRequestimate.currentState,
    dateUpdated: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
  };
  await this.updateRequestOfferedState(offer);

  await this.addRequestState(
    request.requestId,
    updatedRequestimate.currentState,
    null
  );
  
  await this.updateReferralStatusFromRequest('finished');

  // UPDATED: Enhanced invoice creation with failure logging
  try {
    console.log("EXPLICIT: Creating invoice for completed job:", request.requestId);
    const invoice = {
      invoiceId: request.requestId,
      invoiceType: request.requestType,
    };
    
    const apiEndpoint = `/invoices/`;
    const { data: invoiceId } = await API.post(apiEndpoint, invoice);
    console.log("EXPLICIT: Invoice created successfully:", invoiceId);
    
    if (invoiceId) {
      updatedRequestimate.invoiceId = invoiceId;
    }
    
  } catch (invoiceError) {
    console.error("EXPLICIT: Invoice creation failed for request", request.requestId, ":", invoiceError);
    
    // NEW: Log the failure for debugging
    await this.logPaymentFailure('invoice_creation', 'handleComplete', invoiceError);
    
    alert("Job completed successfully, but there was an issue creating the invoice. Please check the invoices section or contact support.");
  }

  await this.clearRequestimate();

  console.log("Handle Complete : request : ", request);

  if (request.requestType === "dealer") {
    // For dealer jobs, notify the dealer contact person
    const contactId = request.dealerContact || request.dealer_contact || request.requestor;
    let data = {
      messageType: "User",
      messagePlatform: "SMS",
      userType: "dealer",
      id: contactId,
      text: `${this.props.companyName} has finished the work on your vehicle`,
    };
    this.sendMessage(data);
  } else {
    // For retail/customer jobs, notify the customer on record
    let data = {
      messageType: "Customer",
      messagePlatform: "SMS",
      userType: "customer",
      id: request.requestor,
      text: `${this.props.companyName} has finished the work on your vehicle. Check your email for your invoice`,
    };
    this.sendMessage(data);
  }
  ReactGA.event({
    category: "Installer",
    action: "Finished Job",
    label: "prod",
  });
  alert("We'll let them know you have finished the work");
  window.location = "/pickups";
};

handleSettle = async (request, invoice, paymentMethod, checkNumber) => {
  // Only used for a job by an installer
//  //console.log("Mark as paid");
//  //console.log("Settle Request", request);
  if (request){
  await this.settleInvoice(invoice);

  await this.updatePayment(request, paymentMethod);
    // if there is a check number then update the installer payment table with the check number in the payment_id field
    if (checkNumber)
      await this.updateInstallerPayment(request, checkNumber);

  }
  await this.addRequestState(request.requestId, "paid", null);
   ReactGA.event({category: 'Installer', action: 'Paid for Service', label: 'dev'});
   alert("We've marked the invoice as closed with payment collected");
   window.location = "/pickups";
};

  handleResend = async (invoice) => {
    // Only used for a job by an installer
    //  //console.log("resending invoice");
    this.resendInvoice(invoice);
    alert("A copy of the invoice has been sent");
    window.location = "/pickups";
  };

  handleFinalize = async (invoice) => {
    // Only used for a job by an installer
    //  //console.log("Finalizing invoice");
    await this.finalizeInvoice(invoice);
    alert("A copy of the invoice has been sent");
    window.location = "/pickups";
  };

  handleDeliver = async (request) => {
    // Only used for a job by an installer
    const updatedRequestimate = request;
    updatedRequestimate.currentState = "collected";
    // update the request
    await this.updateRequest(updatedRequestimate);
    const offer = {
      requestId: updatedRequestimate.requestId,
      installerId: parseInt(this.state.typeId),
      currentStatus: updatedRequestimate.currentState,
      dateUpdated: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    };
    await this.updateRequestOfferedState(offer);

    await this.updateReferralStatusFromRequest('collected')

    // if this is a dealer job, then we create the transfer of the invoice amount to the specialist
    // we double the fee from 5% to 10% and then convert those dollars to cents for the transfer

    if (request.requestType === "dealer") {
      // COMMENTED OUT until FUNDED   await this.createTransfer(transferReq);
    }

    // add an audit record to the table
    await this.addRequestState(
      request.requestId,
      updatedRequestimate.currentState,
      null
    );
    await this.clearRequestimate();
    ReactGA.event({
      category: "Installer",
      action: "Collected Vehicle",
      label: "prod",
    });
    //  window.location = "/pickups";
  };

  handleReview = async (request) => {
    // Only used for a job by a dealer
    const updatedRequestimate = request;
    updatedRequestimate.currentState = "reviewed";
    updatedRequestimate.reviewScore = this.state.reviewScore;
    // update the request
    let urequest = await this.updateRequest(updatedRequestimate);
    const offer = {
      requestId: updatedRequestimate.requestId,
      installerId: updatedRequestimate.assignedTo,
      currentStatus: updatedRequestimate.currentState,
      dateUpdated: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    };
    let uoffered = await this.updateRequestOfferedState(offer);

    // add an audit record to the table
    let astate = await this.addRequestState(
      request.requestId,
      updatedRequestimate.currentState,
      null
    );
    this.setState({ reviewScore: 0 });
    await this.clearRequestimate();
    Promise.all([urequest, uoffered, astate]).then(() => {
      ReactGA.event({
        category: "Dealer",
        action: "Reviewed Job",
        label: "prod",
      });
      alert(
        "Thank you for the review. Reviews are critical to maintaining an installers reputation"
      );
      window.location = "/pickups";
    });
  };

handlePayment = async (invoice) => {
  //console.log("handlePayment called with selectedPay:", this.state.selectedPay);

  if (this.state.selectedPay === "Check") {
    // Validate check number is entered
    if (!this.state.checkNumber.trim()) {
      alert("Please enter a check number");
      return;
    }
    await this.handleSettle(this.state.selectedRequestimate, this.state.invoice.id, "Check", this.state.checkNumber);
  }

  if (this.state.selectedPay === "Cash") {
    await this.handleSettle(this.state.selectedRequestimate, this.state.invoice.id, "Cash");
  }

  if (this.state.selectedPay === "Settle") {
    await this.handleSettle(this.state.selectedRequestimate, this.state.invoice.id);
  }

  // Legacy support for old "Check/Cash" option if it still exists
  if (this.state.selectedPay === "Check/Cash") {
    await this.handleSettle(this.state.selectedRequestimate, this.state.invoice.id);
  }

  if (this.state.selectedPay === "Pay Online") {
    // Fetch fresh invoice URL from Stripe (stored URLs expire after 30-120 days)
    try {
      const { data } = await API.get(`/invoices/${this.state.invoice.id}/fresh-url`);
      if (data.success && data.hosted_invoice_url) {
        window.open(data.hosted_invoice_url);
      } else {
        console.error("Failed to get fresh invoice URL");
        alert("Unable to open invoice. Please try again.");
      }
    } catch (error) {
      console.error("Error fetching fresh invoice URL:", error);
      alert("Unable to open invoice. Please try again.");
    }
  }

  if (this.state.selectedPay === "Swipe Card") {
    // NEW: Start the automated progress flow
    await this.handleSwipeCardFlow();
  }
};

handleSwipeCardFlow = async () => {
  // FIX: Reset invoice settlement flag for new payment attempt
  this.invoiceSettled = false;

  this.setState({
    showSwipe: true,
    paymentState: "initializing",
    paymentError: null
  });

  try {
    // Step 1: Brief initialization pause for UX
    await this.sleep(800);

    // Step 2: Create/verify payment intent
    this.setState({ paymentState: "creating_intent" });
    if (!this.state.paymentIntentId) {
      await this.createSwipe();
    }
    await this.sleep(500);

    // Step 3: Check terminal status
    this.setState({ paymentState: "checking_terminal" });
    const terminalStatus = await this.checkTerminal(this.state.installer.stripe_location);
    await this.sleep(500);

    if (terminalStatus.status !== "online") {
      this.setState({
        paymentState: "terminal_offline",
        paymentError: "Card reader is offline. Please check connection."
      });
      return;
    }

    // Step 4: Send payment to terminal
    this.setState({ paymentState: "sending_to_reader" });
    await this.collectPayment();
    await this.sleep(500);

    // Step 5: Wait for customer interaction
    this.setState({ paymentState: "waiting_for_customer" });

    // Step 6: Start auto-polling for completion
    this.startPaymentPolling();

  } catch (error) {
    console.error("Swipe card flow error:", error);
    this.setState({
      paymentState: "error",
      paymentError: error.message || "Payment setup failed. Please try again."
    });
  }
};
// NEW: Add helper function for timing
sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

checkSwipe = async () => {
  try {
    //console.log("checkSwipe: Checking payment status");

    if (!this.state.paymentIntentId) {
      console.error("No payment ID for status check");
      return;
    }

    const { data: response } = await API.get(`/payments/${this.state.paymentIntentId}`);
    //console.log("checkSwipe: Payment status response:", response);

    // FIXED: Handle new response structure
    if (!response.success) {
      console.error("Payment status check failed:", response.error);
      return { status: "error" };
    }

    const paymentData = response;

    // REMOVED: Client-side invoice settlement for terminal payments
    // The webhook now handles marking invoices as paid when charge.succeeded fires
    // This prevents race conditions where the client might not see the payment status in time

    return paymentData;
  } catch (error) {
    console.error("checkSwipe: Error:", error);
    return { status: "error" };
  }
};

// NEW: Add enhanced polling with better state management
startPaymentPolling = () => {
  // FIX: Clear any existing polling interval first to prevent multiple loops
  if (this.state.paymentPollInterval) {
    console.log("Clearing existing polling interval before starting new one");
    clearInterval(this.state.paymentPollInterval);
  }

  // FIX: Clear any existing timeout
  if (this.pollTimeout) {
    clearTimeout(this.pollTimeout);
  }

  const pollInterval = setInterval(async () => {
    try {
      // FIX: Expanded state check to stop polling in more cases
      if (this.state.paymentState !== "waiting_for_customer" &&
          this.state.paymentState !== "processing") {
        clearInterval(pollInterval);
        return;
      }

      const result = await this.checkSwipe();

      if (result && result.status === "processing") {
        this.setState({ paymentState: "processing" });
      } else if (result && result.status === "succeeded") {
        clearInterval(pollInterval);
        this.setState({ paymentState: "success" });

        // Auto-close after showing success
        setTimeout(() => {
          this.setState({ showSwipe: false, paymentState: "idle" });
          alert("Payment processed successfully!");
          window.location = "/pickups";
        }, 3000);

      } else if (result && result.status === "payment_failed") {
        clearInterval(pollInterval);
        this.setState({
          paymentState: "declined",
          paymentError: "The card was declined. Please try a different card."
        });
      } else if (result && result.status === "error") {
        clearInterval(pollInterval);
        this.setState({
          paymentState: "error",
          paymentError: "Payment status check failed. Please try again."
        });
      }
    } catch (error) {
      console.error("Payment polling error:", error);
      // FIX: Stop polling on critical errors
      clearInterval(pollInterval);
      this.setState({
        paymentState: "error",
        paymentError: "Connection error. Please check your network."
      });
    }
  }, 2000);

  this.setState({ paymentPollInterval: pollInterval });

  // FIX: Store timeout reference so we can clear it later
  this.pollTimeout = setTimeout(() => {
    clearInterval(pollInterval);
    if (this.state.paymentState === "waiting_for_customer" ||
        this.state.paymentState === "processing") {
      this.setState({
        paymentState: "timeout",
        paymentError: "Payment timed out. Please try again."
      });
    }
  }, 300000);
};

// ============================================================================
// SPLIT PAYMENT HANDLERS
// ============================================================================

/**
 * Determine if payment data should be loaded for split payments
 * Only load when: non-dealer, work finished, invoice exists
 */
shouldLoadPaymentData = () => {
  const { selectedRequestimate, finalInvoiceId } = this.state;

  if (!selectedRequestimate || !selectedRequestimate.requestId) {
    return false;
  }

  // Dealers cannot use split payments
  if (selectedRequestimate.requestType === 'dealer') {
    return false;
  }

  // Must have completed work
  if (selectedRequestimate.currentState !== 'finished' && selectedRequestimate.currentState !== 'collected') {
    return false;
  }

  // Must have final invoice created
  if (!finalInvoiceId) {
    return false;
  }

  return true;
};

/**
 * Load payment history for the selected request
 * Only called when split payments are eligible
 */
loadPaymentHistory = async () => {
  const { selectedRequestimate } = this.state;

  if (!this.shouldLoadPaymentData()) {
    return { collectedPayments: [], finalInvoiceId: null };
  }

  try {
    const { data } = await API.get(`/payments/by-request/${selectedRequestimate.requestId}`);

    // Find final invoice parent record
    const finalParent = data.payments.find(p =>
      p.payment_type === 'final' || p.payment_type === 'final_parent'
    );

    // Find split payments (children)
    // Note: Server may return truncated payment_type 'final_spli' instead of 'final_split'
    // Cash payments may not have parent_invoice_id set - use is_partial_payment as fallback
    const finalSplits = data.payments.filter(p => {
      const isSplitType = p.payment_type === 'final_split' || p.payment_type === 'final_spli';
      const isPartial = p.is_partial_payment === 1;
      const hasMatchingParent = p.parent_invoice_id === finalParent?.invoice_id ||
                                 p.parent_invoice_id === this.state.finalInvoiceId;

      // Include if: (split type OR partial payment) AND (has matching parent OR is partial with no parent set)
      return (isSplitType || isPartial) && (hasMatchingParent || (isPartial && !p.parent_invoice_id));
    });

    // Determine if already in split payment mode
    const isSplit = finalSplits.length > 0 || finalSplits.some(p => p.is_partial_payment === 1);

    const newFinalInvoiceId = finalParent?.invoice_id || this.state.finalInvoiceId;

    this.setState({
      collectedPayments: finalSplits,
      isSplitPayment: isSplit,
      finalInvoiceId: newFinalInvoiceId
    });

    // Return the data for immediate use (avoids setState async issue)
    return { collectedPayments: finalSplits, finalInvoiceId: newFinalInvoiceId };

  } catch (error) {
    console.error('Error loading payment history:', error);
    return { collectedPayments: [], finalInvoiceId: null };
  }
};

/**
 * Calculate remaining balance for split payments
 * Formula: (Job Total - Discount + Sales Tax) - Deposit - Collected Splits
 * @param {Array} paymentsOverride - Optional array of payments to use instead of state
 */
calculateRemainingBalance = (paymentsOverride = null) => {
  const { selectedRequestimate, collectedPayments } = this.state;

  // Use provided payments or fall back to state
  const payments = paymentsOverride || collectedPayments;

  if (!selectedRequestimate) return 0;

  // Calculate customer total (what customer actually owes)
  const requestTotal = parseFloat(selectedRequestimate.requestTotal) || 0;
  const requestDiscount = parseFloat(selectedRequestimate.requestDiscount) || 0;
  const requestTaxes = parseFloat(selectedRequestimate.requestTaxes) || 0;

  // Customer pays: (total - discount) + taxes
  const finalAmount = requestTotal - requestDiscount;
  const customerTotal = finalAmount + requestTaxes;

  // Deposit already paid (credited to final invoice)
  const depositAmount = parseFloat(selectedRequestimate.depositAmount) || 0;

  // Sum of paid split payments
  // Note: Cash payments may return as 'pending' from server - treat them as paid
  const splitsPaid = payments
    .filter(p => p.payment_state === 'paid' ||
      (p.payment_state === 'pending' && (p.payment_method?.toLowerCase() === 'cash')))
    .reduce((sum, p) => sum + (parseFloat(p.payment_amount) || parseFloat(p.amount) || parseFloat(p.invoice_amount) || 0), 0);

  // Remaining = Customer Total - Deposit - Splits
  const remaining = customerTotal - depositAmount - splitsPaid;

  return Math.max(0, remaining);
};

/**
 * Handle split payment checkbox toggle
 */
handleToggleSplitPayment = async (e) => {
  const checked = e.target.checked;

  if (checked) {
    const confirmed = window.confirm(
      "Split Payment Mode\n\n" +
      "Collect multiple payments for this invoice.\n\n" +
      "⚠️ Important:\n" +
      "• Customer must complete ALL payments before leaving\n" +
      "• Each payment will be processed separately\n" +
      "• You can mix Terminal, Online, Cash, and Check payments\n\n" +
      "Continue?"
    );

    if (!confirmed) {
      return;
    }

    // Reload payment history in case of existing splits
    await this.loadPaymentHistory();

    this.setState({ isSplitPayment: true });

  } else {
    // Can only exit split mode if no payments collected
    if (this.state.collectedPayments.length === 0) {
      this.setState({ isSplitPayment: false });
    } else {
      alert(
        'Cannot exit split payment mode.\n\n' +
        'Payments have already been collected. ' +
        'You must complete the remaining balance.'
      );
    }
  }
};

/**
 * Validate split payment before processing
 */
validateSplitPayment = () => {
  const { selectedSplitMethod, splitCheckNumber, splitPaymentAmount } = this.state;

  // Must select payment method
  if (!selectedSplitMethod) {
    return {
      valid: false,
      error: 'Please select a payment method (Terminal, Online, Cash, or Check)'
    };
  }

  // Check requires check number
  if (selectedSplitMethod === 'Check' && !splitCheckNumber.trim()) {
    return {
      valid: false,
      error: 'Please enter the check number'
    };
  }

  // Validate amount
  const remainingBalance = this.calculateRemainingBalance();
  const amountInDollars = splitPaymentAmount
    ? parseFloat(splitPaymentAmount)
    : remainingBalance;

  if (isNaN(amountInDollars) || amountInDollars <= 0) {
    return {
      valid: false,
      error: 'Payment amount must be greater than zero'
    };
  }

  if (amountInDollars > remainingBalance) {
    return {
      valid: false,
      error: `Payment amount ($${amountInDollars.toFixed(2)}) cannot exceed remaining balance ($${remainingBalance.toFixed(2)})`
    };
  }

  return { valid: true };
};

/**
 * Main handler for collecting a split payment
 */
handleCollectSplitPayment = async () => {
  const {
    finalInvoiceId,
    selectedRequestimate,
    typeId,
    splitPaymentAmount,
    selectedSplitMethod,
    splitCheckNumber,
    collectedPayments
  } = this.state;

  // Validate payment
  const validation = this.validateSplitPayment();
  if (!validation.valid) {
    alert(validation.error);
    return;
  }

  // Get amount (use input or full remaining)
  const remainingBalance = this.calculateRemainingBalance();
  const amountInDollars = splitPaymentAmount
    ? parseFloat(splitPaymentAmount)
    : remainingBalance;

  this.setState({
    isProcessingSplitPayment: true,
    splitPaymentError: null
  });

  try {
    // HANDLE ONLINE CARD PAYMENT (creates invoice like deposits)
    if (selectedSplitMethod === 'Online') {
      await this.handleCollectOnlineSplitPayment(amountInDollars);
      return; // Online flow handles its own completion
    }

    // HANDLE OTHER PAYMENT METHODS (Terminal, Cash, Check)
    const requestBody = {
      invoiceId: finalInvoiceId,
      requestId: selectedRequestimate.requestId,
      installerId: typeId,
      amount: amountInDollars,
      paymentMethod: selectedSplitMethod,
      sequence: collectedPayments.length + 1
    };

    // Add check number if paying by check
    if (selectedSplitMethod === 'Check') {
      requestBody.checkNumber = splitCheckNumber.trim();
    }

    // Call backend API to record payment
    const { data: response } = await API.post('/invoices/record-partial', requestBody);

    if (!response.success) {
      throw new Error(response.error || 'Failed to record payment');
    }

    // If terminal payment, process on card reader
    if (selectedSplitMethod === 'Terminal' && response.payment_intent_id) {
      await this.processTerminalSplitPayment(response.payment_intent_id);
    }

    // For Cash and Check, backend marks as paid immediately

    // Reload payment history to get updated state
    const { collectedPayments: updatedPayments } = await this.loadPaymentHistory();

    // Check if fully paid - use returned data to avoid setState async issue
    const newRemaining = this.calculateRemainingBalance(updatedPayments);

    if (newRemaining === 0) {
      alert(
        'Payment collected successfully!\n\n' +
        '✓ All payments complete\n' +
        '✓ Invoice is fully paid\n\n' +
        'You can now close this screen.'
      );
      this.setState({ isSplitPayment: false });
    } else {
      alert(
        `Payment ${updatedPayments.length} collected!\n\n` +
        `Remaining balance: $${newRemaining.toFixed(2)}`
      );
    }

    // Reset form
    this.setState({
      splitPaymentAmount: '',
      selectedSplitMethod: null,
      splitCheckNumber: ''
    });

  } catch (error) {
    console.error('Error collecting split payment:', error);

    const errorMsg = error.response?.data?.error || error.message || 'Unknown error';

    this.setState({ splitPaymentError: errorMsg });

    alert(`Error collecting payment:\n\n${errorMsg}`);

  } finally {
    this.setState({ isProcessingSplitPayment: false });
  }
};

/**
 * Handle online card split payment (creates partial invoice)
 */
handleCollectOnlineSplitPayment = async (amountInDollars) => {
  // Check if Stripe capabilities are active
  if (!this.validateStripeCapabilities()) return;

  const { selectedRequestimate, collectedPayments, finalInvoiceId } = this.state;

  try {
    // Create partial invoice (same pattern as deposits)
    const invoice = {
      invoiceId: `${selectedRequestimate.requestId}-split${collectedPayments.length + 1}-${Date.now()}`,
      invoiceType: selectedRequestimate.requestType,
      amount: amountInDollars,
      metadata: {
        payment_type: 'final_split',
        parent_invoice_id: finalInvoiceId,
        payment_sequence: collectedPayments.length + 1,
        is_partial_payment: 'true',
        request_id: selectedRequestimate.requestId
      }
    };

    const { data: response } = await API.post('/invoices/', invoice);

    // Auto-send the invoice to customer
    if (response.id) {
      await this.resendInvoice(response.id);
    }

    // Reload payment history to get updated state
    const { collectedPayments: updatedPayments } = await this.loadPaymentHistory();

    // Check if fully paid
    const newRemaining = this.calculateRemainingBalance(updatedPayments);

    this.setState({ isProcessingSplitPayment: false });

    if (newRemaining === 0) {
      // Fully paid - close modal and refresh
      alert(
        `Invoice sent to customer!\n\n` +
        `Amount: $${amountInDollars.toFixed(2)}\n\n` +
        `✓ All payments complete - invoice is fully paid.`
      );
      this.setState({ isSplitPayment: false });
      // Refresh to update the UI
      window.location.reload();
    } else {
      // More payments needed
      alert(
        `Invoice sent to customer!\n\n` +
        `Amount: $${amountInDollars.toFixed(2)}\n` +
        `Remaining balance: $${newRemaining.toFixed(2)}`
      );
      // Reset form for next payment
      this.setState({
        splitPaymentAmount: '',
        selectedSplitMethod: null
      });
    }

  } catch (error) {
    console.error('Error creating online split invoice:', error);
    this.setState({ isProcessingSplitPayment: false });
    throw error;
  }
};

/**
 * Process a split payment on the terminal reader
 */
processTerminalSplitPayment = async (paymentIntentId) => {
  try {
    // Use existing terminal payment infrastructure
    const payment = {
      paymentId: paymentIntentId,
      terminalId: this.state.installer.stripe_location
    };

    const { data: response } = await API.post('/terminalPay/', payment);

    if (!response.success) {
      throw new Error(response.error || 'Terminal payment failed');
    }

    // Poll for webhook to update payment status
    await this.pollForSplitPaymentCompletion(paymentIntentId);

  } catch (error) {
    console.error('Terminal split payment error:', error);
    throw error;
  }
};

/**
 * Poll backend to check if split payment completed via webhook
 */
pollForSplitPaymentCompletion = async (paymentIntentId, maxAttempts = 15) => {
  for (let i = 0; i < maxAttempts; i++) {
    // Wait 1 second between attempts
    await new Promise(resolve => setTimeout(resolve, 1000));

    try {
      // Reload payment history
      const { data } = await API.get(`/payments/by-request/${this.state.selectedRequestimate.requestId}`);

      // Find this payment
      const payment = data.payments.find(p => p.payment_intent_id === paymentIntentId);

      if (payment) {
        if (payment.payment_state === 'paid') {
          return true;
        }

        if (payment.payment_state === 'failed') {
          throw new Error('Payment failed - please try again');
        }
      }

    } catch (error) {
      console.warn(`Polling attempt ${i + 1} failed:`, error);
    }
  }

  // Timeout
  throw new Error(
    'Payment confirmation timeout. ' +
    'Please refresh the page to check payment status.'
  );
};

/**
 * Close invoice link modal and refresh payment data
 */
handleCloseInvoiceLinkModal = async () => {
  this.setState({
    showInvoiceLinkModal: false,
    currentInvoiceLink: null,
    splitPaymentAmount: '',
    selectedSplitMethod: null
  });

  // Reload payment history to show pending invoice
  await this.loadPaymentHistory();
};

// ============================================================================
// END SPLIT PAYMENT HANDLERS
// ============================================================================

  handleAddPO = async (PO) => {
    //  //console.log ("This is where we add this PO to the current invoice", PO)

    await this.updateInvoiceMetadata(this.state.invoice.id, PO);

    this.setState({ showPO: false });
    window.location = "/pickups";
  };

  handleSelectCalendar = async (calendar) => {
    /*console.log(
      "This is what we are updating in the DB for Calendar",
      calendar
    );*/
    let calId = "primary";
    if (calendar.name !== calendar.id) calId = calendar.id;

    await this.updateInstallerLocation(calId);
    this.setState({ showCalendar: false });
    alert("Calendar updated.");
    this.props.onSwitch(this.props.typeId);
  };

// REPLACE the existing handleRequestimateSelect method in requestimates.jsx

handleRequestimateSelect = async (requestimate) => {
 //console.log("Requestimate selected:", requestimate);

  // Prevent re-selection of the same request
  if (this.state.selectedRequestimate?.requestId === requestimate.requestId) {
   //console.log("Same request already selected, skipping");
    return;
  }

  // Detect if we should hide the list (mobile/tablet or narrow window)
  // Use screen width check instead of user agent for more reliable detection
  // Bootstrap lg breakpoint is 992px - hide list below that
  const shouldHideList = window.innerWidth < 992;

  // Set loading state immediately for better UX, and hide list on smaller screens
  this.setState({
    loading: true,
    hiddenList: shouldHideList // Hide list on smaller screens when selecting a record
  });
  
  try {
    // Set the upstream request
    await this.props.selectRequest(requestimate.requestId);

    // Prepare core API calls that we'll handle manually
    const coreApiPromises = [];
    const promiseTypes = [];

    // Services API call
    coreApiPromises.push(
      API.get(`/requestService/${requestimate.requestId}`).then(({ data: services }) => {
        // Process services like the original method
        for (let i = 0; i < services.length; i++) {
          if (services[i].custom_description) {
            services[i].Description = services[i].custom_description;
          }
        }
        return services;
      })
    );
    promiseTypes.push('services');

    // Request states API call
    coreApiPromises.push(
      API.get(`/requeststate/${requestimate.requestId}`).then(({ data: history }) => {
        let selectHistory = history.filter(
          (item) => item.requestId === requestimate.requestId
        );
        return selectHistory;
      })
    );
    promiseTypes.push('states');

    // Notes API call
    coreApiPromises.push(
      API.get(`/requestnotes/${requestimate.requestId}`).then(({ data: notes }) => notes)
    );
    promiseTypes.push('notes');

    // Offers API call
    coreApiPromises.push(
      API.get(`/requestoffered/request/${requestimate.requestId}`).then(({ data: offers }) => offers)
    );
    promiseTypes.push('offers');

        // NEW: Referral check API call
    coreApiPromises.push(
      console.log('Fetching referral for request:', requestimate.requestId) ||
      API.get(`/requestreferral/${requestimate.requestId}`)
        .then(({ data: referralData }) => {
          // Return referral info or null if no referral found
          return referralData && referralData.length > 0 ? referralData[0] : null;
        })
        .catch((error) => {
          // Silent failure - many requests won't have referrals
          console.log('No referral found for request:', requestimate.requestId);
          return null;
        })
    );
    promiseTypes.push('referral');

    // NEW: Calendar data for this specific request (for both dealers and installers)
    if (['scheduled', 'received', 'started', 'finished'].includes(requestimate.currentState)) {
      coreApiPromises.push(
        API.get(`/installerCalendarRequest/${requestimate.requestId}`)
          .then(({ data: requestCalendarDays }) => requestCalendarDays)
      );
      promiseTypes.push('requestCalendar');
    }

    // Vehicle images from check-in AND completion - fetch all photos in one call
    // Also extracts odometer_reading, plate, and carfax_opt_out for deferred CarFax data collection
    coreApiPromises.push(
      API.get(`/requests/${requestimate.requestId}/checkin/status`)
        .then(({ data: checkinData }) => {
          let allPhotoKeys = [];

          // Extract CarFax-relevant fields from checkin data
          const odometerReading = checkinData?.data?.odometer_reading || null;
          const plate = checkinData?.data?.plate || null;
          const carfaxOptOut = checkinData?.data?.carfax_opt_out || false;

          // Extract condition_photos from the nested data object
          if (checkinData?.data?.condition_photos && Array.isArray(checkinData.data.condition_photos)) {
            const conditionPhotos = checkinData.data.condition_photos.map((photo, index) => ({
              s3_key: photo.s3_key,
              id: photo.id,
              sequence: photo.photo_sequence,
              uploaded_at: photo.uploaded_at,
              caption: photo.photo_type === 'completion'
                ? `Completion - Photo ${index + 1}`
                : `Check-In - Condition Photo ${index + 1}`,
              type: photo.photo_type || 'checkin'
            }));
            allPhotoKeys = [...allPhotoKeys, ...conditionPhotos];
          }

          // Add odometer photo if it exists
          if (checkinData?.data?.odometer_photo_s3_key) {
            allPhotoKeys.push({
              s3_key: checkinData.data.odometer_photo_s3_key,
              id: 'odometer',
              sequence: 998,
              caption: 'Check-In - Odometer Reading',
              type: 'odometer'
            });
          }

          return { allPhotoKeys, odometerReading, plate, carfaxOptOut };
        })
        .catch((error) => {
          console.error('Error fetching photos:', error);
          return { allPhotoKeys: [], odometerReading: null, plate: null, carfaxOptOut: false };
        })
        .then(async ({ allPhotoKeys, odometerReading, plate, carfaxOptOut }) => {
          // Fetch signed URLs for all photos
          let photos = [];
          if (allPhotoKeys.length > 0) {
            const urlPromises = allPhotoKeys.map(async (photo) => {
              try {
                const response = await API.get(`/checkin/photo/signed-url?s3Key=${encodeURIComponent(photo.s3_key)}`);
                return {
                  url: response.data.signedUrl || response.data.url,
                  photo_url: response.data.signedUrl || response.data.url,
                  caption: photo.caption,
                  sequence: photo.sequence,
                  id: photo.id,
                  type: photo.type
                };
              } catch (error) {
                console.error('Error fetching signed URL for photo:', photo.s3_key, error);
                return null;
              }
            });

            photos = (await Promise.all(urlPromises)).filter(p => p !== null);

            // Sort by sequence to maintain order: checkin photos first, then completion
            photos.sort((a, b) => a.sequence - b.sequence);
          }

          return { photos, odometerReading, plate, carfaxOptOut };
        })
    );
    promiseTypes.push('vehicleImages');

    // Conditional API calls
    if (requestimate.invoiceId) {
      coreApiPromises.push(
        API.get(`/invoices/${requestimate.invoiceId}`).then(({ data: invoice }) => invoice)
      );
      promiseTypes.push('invoice');
    }

    if (this.state.userType === "dealer" && requestimate.assignedTo) {
      coreApiPromises.push(
        API.get(`/installerLocations/${requestimate.assignedTo}`).then(({ data: installer }) => {
          const firstOne = installer.shift();
          return firstOne;
        })
      );
      promiseTypes.push('installer');
    }

    // Execute all API calls in parallel
    const results = await Promise.allSettled(coreApiPromises);

    // Process results and build state update object
    const stateUpdate = this.processParallelResults(results, promiseTypes, requestimate);

    // Calculate initial date state ONCE without triggering onStartDateChange
    // Priority: offer startDate > request availableDate > dueDate
    let initialStartDate = requestimate.availableDate || requestimate.dueDate;
    if (stateUpdate.selectedOffers && stateUpdate.selectedOffers.length === 1) {
      initialStartDate = stateUpdate.selectedOffers[0].startDate;
    }
    
    // Add the calculated start date to state update
    stateUpdate.startDate = initialStartDate;

    // Only fetch availability for installer booking scenarios, and only if needed
    if (this.state.userType === "installer") {
      const needsAvailability = (
        requestimate.currentState === "new" ||        // All booking scenarios
        requestimate.currentState === "scheduled"     // Rescheduling scenarios
      );
      
      if (needsAvailability) {
        try {
          const dateParam = moment(initialStartDate).format('YYYY-MM-DD');
          // Use the request's own location, not the nav selector
          const reqLocId = requestimate.location_id || requestimate.locationId;
          const selLocParam = reqLocId && reqLocId !== 0 && reqLocId !== '0'
            ? `&locationId=${reqLocId}` : '';
          const { data: availability } = await API.get(
            `/availability/${this.state.typeId}/${requestimate.requestId}?checkDate=${dateParam}${selLocParam}`
          );
          stateUpdate.availability = availability;

          // Only override startDate with availability suggestion if the request's
          // available date is in the past — otherwise respect the customer's requested date
          if (availability && availability.nextStart) {
            const requestedDate = moment(initialStartDate);
            if (requestedDate.isBefore(moment().startOf('day'))) {
              const nextStartDateOnly = availability.nextStart.substring(0, 10) + 'T12:00:00';
              stateUpdate.startDate = new Date(nextStartDateOnly);
            }
          }
        } catch (availabilityError) {
         //console.log('Availability fetch failed, using fallback:', availabilityError.message);
          stateUpdate.availability = null;
        }
      }
    }

    // Single state update with all data - NO onStartDateChange call
    this.setState(stateUpdate, () => {
      // After state is set, load payment history if eligible for split payments
      if (this.shouldLoadPaymentData()) {
        this.loadPaymentHistory();
      }
      // Fetch service items for services that have them
      this.loadServiceItems(stateUpdate.services || []);
    });

  } catch (error) {
    console.error('Error loading requestimate details:', error);
    // Show error state or fallback - maintain existing structure
    this.setState({
      selectedRequestimate: requestimate,
      services: [],
      requestStates: [],
      requestNotes: [],
      requestOffers: [],
      selectedOffers: [],
      invoice: {},
      finalInvoiceId: null,
      availability: null,
      selectedService: 0,
      activePage: 1,
      vinGood: !requestimate.vin.startsWith("NV"),
      startDate: requestimate.dueDate,
      requestCalendarDays: [], // NEW: Add empty calendar data on error
      loading: false,
      referralData: null, // NEW: Initialize referral data on error
    });
  } finally {
    // Ensure loading state is cleared
    this.setState({ loading: false });
  }
};

// FIND the processParallelResults method in requestimates.jsx (around line 2000-2100)
// REPLACE it with this updated version that handles referral data

processParallelResults = (results, promiseTypes, requestimate) => {
  // Create a working copy of the requestimate
  let updatedRequestimate = { ...requestimate };
  
  const stateUpdate = {
    selectedRequestimate: updatedRequestimate,
    selectedService: 0,
    activePage: 1,
    vinGood: !requestimate.vin.startsWith("NV"),
    services: [],
    requestStates: [],
    requestNotes: [],
    requestOffers: [],
    selectedOffers: [],
    invoice: {},
    finalInvoiceId: null, // Initialize for split payment feature
    installer: this.state.installer, // Keep existing installer unless updated
    availability: null,
    startDate: requestimate.availableDate || requestimate.dueDate,
    requestCalendarDays: [],
    referralData: null // NEW: Initialize referral data
  };

  // Process each result based on its type
  results.forEach((result, index) => {
    const type = promiseTypes[index];

    if (result.status === 'fulfilled') {
      switch (type) {
        case 'services':
          stateUpdate.services = result.value || [];
          break;

        case 'states':
          stateUpdate.requestStates = result.value || [];
          break;

        case 'notes':
          stateUpdate.requestNotes = result.value || [];
          break;

        case 'offers':
          stateUpdate.requestOffers = result.value || [];
          break;

        case 'invoice':
          const invoice = result.value || {};
          stateUpdate.invoice = invoice;

          // Set finalInvoiceId for split payment feature
          stateUpdate.finalInvoiceId = invoice.id || null;

          // Add invoice number to requestimate if available
          if (invoice && invoice.number) {
            updatedRequestimate.customer_facing_invoice = invoice.number;
            stateUpdate.selectedRequestimate = updatedRequestimate;
          }
          break;

        case 'installer':
          stateUpdate.installer = result.value || this.state.installer;
          break;

        case 'availability':
          stateUpdate.availability = result.value || null;
          break;

        // Handle request calendar data with field mapping
        case 'requestCalendar':
          const rawCalendarData = result.value || [];
          // Map snake_case API response to camelCase for utility functions
          const mappedCalendarData = rawCalendarData.map(entry => ({
            ...entry,
            workDate: entry.work_date,     // Map work_date -> workDate
            workStatus: entry.work_status, // Map work_status -> workStatus
            requestId: entry.request_id,    // Map request_id -> requestId (if needed)
            duration: entry.daily_work  // Map daily work for other calculation
          }));
          stateUpdate.requestCalendarDays = mappedCalendarData;
          console.log('Request calendar data loaded and mapped:', mappedCalendarData);
          break;

        // NEW: Handle referral data
        case 'referral':
          const referralData = result.value;
          stateUpdate.referralData = referralData;

          // Add referral_id to the selectedRequestimate for easy access during state transitions
          if (referralData && referralData.referral_id) {
            updatedRequestimate.referral_id = referralData.referral_id;
            updatedRequestimate.referral_status = referralData.status;
            stateUpdate.selectedRequestimate = updatedRequestimate;
            console.log('Referral data loaded for request:', referralData.referral_id);
          } else {
            console.log('No referral found for this request');
          }
          break;

        // Handle vehicle images and CarFax data from check-in
        case 'vehicleImages': {
          const checkinResult = result.value || {};
          stateUpdate.vehicleImages = checkinResult.photos || [];
          stateUpdate.checkinOdometerReading = checkinResult.odometerReading || null;
          stateUpdate.checkinPlate = checkinResult.plate || null;
          stateUpdate.checkinCarfaxOptOut = checkinResult.carfaxOptOut || false;
          console.log('Setting vehicleImages in state:', stateUpdate.vehicleImages);
          if (stateUpdate.vehicleImages.length > 0) {
            console.log(`Loaded ${stateUpdate.vehicleImages.length} vehicle images for request`);
          } else {
            console.log('No vehicle images to display');
          }
          break;
        }

        default:
          console.warn(`Unknown promise type: ${type}`);
      }
    } else {
      // Handle failed promises gracefully
      console.error(`Failed to load ${type}:`, result.reason);
      
      // Set default values for failed requests
      switch (type) {
        case 'services':
          stateUpdate.services = [];
          break;
        case 'states':
          stateUpdate.requestStates = [];
          break;
        case 'notes':
          stateUpdate.requestNotes = [];
          break;
        case 'offers':
          stateUpdate.requestOffers = [];
          break;
        case 'invoice':
          stateUpdate.invoice = {};
          break;
        case 'installer':
          stateUpdate.installer = this.state.installer;
          break;
        case 'availability':
          stateUpdate.availability = null;
          break;
        case 'requestCalendar':
          stateUpdate.requestCalendarDays = [];
          break;
        case 'referral':
          stateUpdate.referralData = null;
          // Don't add referral_id to requestimate if the call failed
          break;
        case 'vehicleImages':
          stateUpdate.vehicleImages = [];
          stateUpdate.checkinOdometerReading = null;
          stateUpdate.checkinPlate = null;
          stateUpdate.checkinCarfaxOptOut = false;
          break;
        default:
          break;
      }
    }
  });

  // Process selected offers based on user type (this logic was in the original)
  let selectedOffers = [];
  if (stateUpdate.requestOffers && stateUpdate.requestOffers.length > 0) {
    selectedOffers = stateUpdate.requestOffers.filter(
      (offer) => offer.requestId === requestimate.requestId
    );
    
    if (this.state.userType === "installer") {
      selectedOffers = selectedOffers.filter(
        (offer) => offer.installerId === parseInt(this.state.typeId)
      );
    }
  }
  stateUpdate.selectedOffers = selectedOffers;

  // Determine start date - prefer customer's available date over due date
  let startDate = requestimate.availableDate || requestimate.dueDate;
  if (selectedOffers.length === 1) {
    startDate = selectedOffers[0].startDate;
  }
  stateUpdate.startDate = startDate;

  return stateUpdate;
};

// Helper method to process all API results
processApiResults = (results, promiseTypes, requestimate) => {
  const stateUpdate = {
    selectedRequestimate: { ...requestimate },
    selectedService: 0,
    activePage: 1,
    vinGood: !requestimate.vin.startsWith("NV")
  };

  // Process each result based on its type
  results.forEach((result, index) => {
    const type = promiseTypes[index];
    
    if (result.status === 'fulfilled') {
      switch (type) {
        case 'services':
          // Process services data (add custom descriptions if needed)
          const services = result.value || [];
          services.forEach(service => {
            if (service.custom_description) {
              service.Description = service.custom_description;
            }
          });
          stateUpdate.services = services;
          break;

        case 'states':
          // Process states data (add created date)
          const history = result.value || [];
          let selectHistory = history.filter(
            (item) => item.requestId === requestimate.requestId
          );
          stateUpdate.requestStates = selectHistory;
          break;

        case 'notes':
          stateUpdate.requestNotes = result.value || [];
          break;

        case 'offers':
          stateUpdate.requestOffers = result.value || [];
          break;

        case 'invoice':
          const invoice = result.value || {};
          stateUpdate.invoice = invoice;
          
          // Add invoice number to requestimate if available
          if (invoice && invoice.number) {
            stateUpdate.selectedRequestimate.customer_facing_invoice = invoice.number;
          }
          break;

        case 'installer':
          // This sets this.state.installer via the readInstaller method
          // No additional processing needed here as readInstaller handles setState
          break;

        case 'availability':
          stateUpdate.availability = result.value || null;
          break;

        default:
          console.warn(`Unknown promise type: ${type}`);
      }
    } else {
      // Handle failed promises gracefully
      console.error(`Failed to load ${type}:`, result.reason);
      
      // Set default values for failed requests
      switch (type) {
        case 'services':
          stateUpdate.services = [];
          break;
        case 'states':
          stateUpdate.requestStates = [];
          break;
        case 'notes':
          stateUpdate.requestNotes = [];
          break;
        case 'offers':
          stateUpdate.requestOffers = [];
          break;
        case 'invoice':
          stateUpdate.invoice = {};
          break;
        case 'availability':
          stateUpdate.availability = null;
          break;
        default:
          break;
      }
    }
  });

  // Process selected offers based on user type
  let selectedOffers = [];
  if (stateUpdate.requestOffers) {
    selectedOffers = stateUpdate.requestOffers.filter(
      (offer) => offer.requestId === requestimate.requestId
    );

    if (this.state.userType === "installer") {
      selectedOffers = selectedOffers.filter(
        (offer) => offer.installerId === parseInt(this.state.typeId)
      );
    }
  }
  stateUpdate.selectedOffers = selectedOffers;

  // Determine start date - prefer customer's available date over due date
  let startDate = requestimate.availableDate || requestimate.dueDate;
  if (selectedOffers.length === 1) {
    startDate = selectedOffers[0].startDate;
  }
  stateUpdate.startDate = startDate;

  return stateUpdate;
};

  clearRequestimate = async () => {
    await this.props.selectRequest("");
    this.setState({ selectedRequestimate: "", availability : null });
  };

  handleEdit = async () => {
    window.location = "/editJob/" + this.props.selectedRequest;
  };

  // =========================================================================

  applyListFilter = (list) => {
    const { listFilter } = this.state;
    if (!listFilter) return list;

    const [type, ...valueParts] = listFilter.split(':');
    const value = valueParts.join(':');

    switch (type) {
      case 'channel':
        return list.filter(item => item.requestType === value);
      case 'customer':
        return list.filter(item => item.dealerName === value);
      case 'specialist':
        return list.filter(item => item.installerName === value);
      default:
        return list;
    }
  }

  renderRequestimateFilterDropdown = (requestimateList) => {
    const { listFilter, showFilterDropdown } = this.state;
    const { userType, mode } = this.props;

    // Determine which tabs get a filter
    const noFilterTabs = userType === 'dealer'
      ? ['reviews']
      : [];
    if (noFilterTabs.includes(mode)) return null;

    const isActive = listFilter !== '';

    // Build filter options based on user type
    let sections = [];

    if (userType === 'installer') {
      // Channel section
      const channels = [...new Set(requestimateList.map(r => r.requestType).filter(Boolean))].sort();
      if (channels.length > 0) {
        const channelLabels = { dealer: 'Dealer', installer: 'Retail' };
        sections.push({
          header: 'Channel',
          options: channels.map(ch => ({
            key: `channel:${ch}`,
            label: channelLabels[ch] || ch,
            count: requestimateList.filter(r => r.requestType === ch).length,
            icon: ch === 'dealer'
              ? 'fa-sharp fa-solid fa-handshake'
              : 'fa-sharp fa-solid fa-user'
          }))
        });
      }

      // Customer section
      const customers = [...new Set(requestimateList.map(r => r.dealerName).filter(Boolean))].sort();
      if (customers.length > 1) {
        sections.push({
          header: 'Customer',
          options: customers.map(name => ({
            key: `customer:${name}`,
            label: name,
            count: requestimateList.filter(r => r.dealerName === name).length
          }))
        });
      }
    } else if (userType === 'dealer') {
      // Specialist section
      const specialists = [...new Set(requestimateList.map(r => r.installerName).filter(Boolean))].sort();
      if (specialists.length > 1) {
        sections.push({
          header: null,
          options: specialists.map(name => ({
            key: `specialist:${name}`,
            label: name,
            count: requestimateList.filter(r => r.installerName === name).length
          }))
        });
      }
    }

    // Nothing to filter
    if (sections.length === 0) return null;

    const filteredCount = this.applyListFilter(requestimateList).length;

    return (
      <div style={{ position: 'relative' }}>
        <button
          className={`btn btn-sm btn-header-icon${isActive ? ' filter-active' : ''}`}
          onClick={() => this.setState({ showFilterDropdown: !showFilterDropdown })}
          title="Filter list"
        >
          <i className={`fa-sharp ${isActive ? 'fa-solid' : 'fa-regular'} fa-filter`}></i>
          {isActive && (
            <span style={{
              position: 'absolute', top: '-2px', right: '-2px',
              background: '#fff', color: '#5196d3', borderRadius: '50%',
              fontSize: '9px', fontWeight: 700, width: '14px', height: '14px',
              display: 'flex', alignItems: 'center', justifyContent: 'center'
            }}>
              {filteredCount}
            </span>
          )}
        </button>
        {showFilterDropdown && (
          <>
            <div style={{ position: 'fixed', inset: 0, zIndex: 1049 }}
              onClick={() => this.setState({ showFilterDropdown: false })} />
            <div className="filter-dropdown-menu">
              <div
                className={`filter-item${listFilter === '' ? ' active' : ''}`}
                onClick={() => this.setState({ listFilter: '', showFilterDropdown: false })}
              >
                All ({requestimateList.length})
              </div>
              {sections.map((section, si) => (
                <React.Fragment key={si}>
                  <div className="filter-divider" />
                  {section.header && (
                    <div className="filter-section-header">{section.header}</div>
                  )}
                  {section.options.map(opt => (
                    <div
                      key={opt.key}
                      className={`filter-item${listFilter === opt.key ? ' active' : ''}`}
                      onClick={() => this.setState({ listFilter: opt.key, showFilterDropdown: false })}
                    >
                      {opt.icon && <i className={opt.icon} style={{ width: '16px', textAlign: 'center' }}></i>}
                      <span>{opt.label} ({opt.count})</span>
                    </div>
                  ))}
                </React.Fragment>
              ))}
            </div>
          </>
        )}
      </div>
    );
  }

  // render logic to display the list, detail and various states
  render() {
    // =================================================

    //console.log("Here are the requests :", this.state.requestimates)

    const { typeId, mode } = this.props;
    const { userType, showHelpVideo } = this.state;
    ReactGA.initialize(process.env.REACT_APP_GA);

  //   //console.log('Requestimates : Company', this.props.company);
    // //console.log('typeId', typeId)
    // //console.log('mode', mode)
    // //console.log('Requestimates : this.props.selectedRequest', this.props.selectedRequest)

    // first let's make sure that if there is a google calendar integrated that we
    // have the right one

    // filter the list of returned information based on the mode
    let requestimateList = [];
    if (userType === "dealer" && mode === "requests") {
      ReactGA.send({ hitType: "pageview", page: "/dealerRequests" });
      requestimateList = this.state.requestimates.filter(
        (req) => req.currentState === "new" || req.currentState === "answered"
      );
      // //console.log(requestimateList)
    }

    if (userType === "dealer" && mode === "jobs") {
      // Parse filter from URL query params (e.g., /jobs?filter=scheduled)
      const searchParams = new URLSearchParams(this.props.location?.search || '');
      const jobFilter = searchParams.get('filter');

      if (jobFilter === 'scheduled') {
        ReactGA.send({ hitType: "pageview", page: "/dealerJobs/scheduled" });
        requestimateList = this.state.requestimates.filter(
          (req) => req.currentState === "scheduled"
        );
      } else if (jobFilter === 'inprogress') {
        ReactGA.send({ hitType: "pageview", page: "/dealerJobs/inprogress" });
        requestimateList = this.state.requestimates.filter(
          (req) =>
            req.currentState === "received" ||
            req.currentState === "started"
        );
      } else {
        // Default: show all jobs (backwards compatibility)
        ReactGA.send({ hitType: "pageview", page: "/dealerJobs" });
        requestimateList = this.state.requestimates.filter(
          (req) =>
            req.currentState === "scheduled" ||
            req.currentState === "started" ||
            req.currentState === "received"
        );
      }
    }

    if (userType === "dealer" && mode === "pickups") {
      ReactGA.send({ hitType: "pageview", page: "/dealerPickups" });
      requestimateList = this.state.requestimates.filter(
        (req) => req.currentState === "finished"
      );
    }

    if (userType === "dealer" && mode === "reviews") {
      ReactGA.send({ hitType: "pageview", page: "/dealerReviews" });
      requestimateList = this.state.requestimates.filter(
        (req) => req.currentState === "collected"
      );
    }

    if (userType === "installer" && mode === "requests") {
      ReactGA.send({ hitType: "pageview", page: "/installerRequests" });
      requestimateList = this.state.requestimates.filter(
        (req) => req.currentState === "new" && req.offerState === "offered"
      );
    }

    if (userType === "installer" && mode === "jobs") {
      // Parse filter from URL query params (e.g., /jobs?filter=scheduled)
      const searchParams = new URLSearchParams(this.props.location?.search || '');
      const jobFilter = searchParams.get('filter');

      if (jobFilter === 'scheduled') {
        ReactGA.send({ hitType: "pageview", page: "/installerJobs/scheduled" });
        requestimateList = this.state.requestimates.filter(
          (req) => req.currentState === "scheduled"
        );
      } else if (jobFilter === 'inprogress') {
        ReactGA.send({ hitType: "pageview", page: "/installerJobs/inprogress" });
        requestimateList = this.state.requestimates.filter(
          (req) =>
            req.currentState === "received" ||
            req.currentState === "started"
        );
      } else {
        // Default: show all jobs (backwards compatibility)
        ReactGA.send({ hitType: "pageview", page: "/installerJobs" });
        requestimateList = this.state.requestimates.filter(
          (req) =>
            req.currentState === "scheduled" ||
            req.currentState === "received" ||
            req.currentState === "started"
        );
      }
      // Sort jobs by scheduled workDate from calendar
      requestimateList = this.sortByCalendarDate(requestimateList);
    }

    if (userType === "installer" && mode === "pickups") {
      ReactGA.send({ hitType: "pageview", page: "/installerPickups" });

      requestimateList = this.state.requestimates.filter(
        (req) => req.currentState === "finished"
      );
      // Sort pickups by scheduled workDate from calendar
      requestimateList = this.sortByCalendarDate(requestimateList);
    }
    let namePage = userType === "dealer" ? "Requests" : "Requestimates";
    if (mode === "jobs") {
      // Check for filter to show specific page name
      const searchParams = new URLSearchParams(this.props.location?.search || '');
      const jobFilter = searchParams.get('filter');
      if (jobFilter === 'scheduled') {
        namePage = "Scheduled";
      } else if (jobFilter === 'inprogress') {
        namePage = "In Progress";
      } else {
        namePage = "Jobs";
      }
    }
    if (mode === "pickups") namePage = "Pickups";
    if (mode === "reviews") namePage = "Reviews";

    // Location filter: specific location view shows own + unclaimed requests
    const multiLoc = isMultiLocation(this.props.locations);
    const allLocView = isAllLocations(this.props.selectedLocationId);
    if (multiLoc && !allLocView) {
      requestimateList = requestimateList.filter(item =>
        isUnclaimed(item) || String(item.location_id || item.locationId) === String(this.props.selectedLocationId)
      );
    }

    // Save unfiltered list for filter dropdown counts, then apply user filter
    const unfilteredList = requestimateList;
    requestimateList = this.applyListFilter(requestimateList);

    // Helper function to get source type class for list items (installer view only)
    const getSourceClass = (item) => {
      if (userType !== "installer") return "";
      return item.requestType === "dealer" ? "source-dealer" : "source-retail";
    };

    function isEmpty(obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) return false;
      }
      return true;
    }

 // Add this debug line
 //console.log("Requestimates company prop:", this.props.company);
 

    return (
      <React.Fragment>
        {(() => {
          //console.log("Portal check at top - showHelpVideo:", showHelpVideo);
          if (showHelpVideo) {
            //console.log("About to render portal at top!");
            return ReactDOM.createPortal(
              <div style={{ 
                position: 'fixed', 
                top: 0, 
                left: 0, 
                right: 0, 
                bottom: 0, 
                backgroundColor: 'rgba(0,0,0,0.8)', 
                zIndex: 999999,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <div style={{ 
                  backgroundColor: 'white', 
                  padding: '20px', 
                  borderRadius: '8px',
                  width: '90%',
                  maxWidth: '1000px',
                  height: '90%',
                  maxHeight: '700px',
                  position: 'relative',
                  display: 'flex',
                  flexDirection: 'column'
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                    <h3 style={{ margin: 0 }}>How to Create {userType === "dealer" ? "Requests" : "Estimates"}</h3>
                    <button
                      onClick={this.handleCloseHelpVideo}
                      style={{
                        background: 'none',
                        border: 'none',
                        fontSize: '28px',
                        cursor: 'pointer',
                        lineHeight: 1
                      }}
                    >
                      &times;
                    </button>
                  </div>
                  <div style={{ flex: 1, backgroundColor: '#f0f0f0', borderRadius: '4px' }}>
<iframe
                          src={userType === "dealer"
                            ? "https://scribehow.com/embed/How_To_Submit_A_Request_to_Jobvious__Bl3baC7SRVOWST-ZTrrWUw?as=video"
                            : "https://scribehow.com/embed/Create_a_New_Estimate_for_a_Customer__1NyVekH2QHiwC4qpcUeUiQ?as=video"}
                          width="100%"
                          height="100%"
                          allowFullScreen
                          style={{ border: 0 }}
                          title={userType === "dealer" ? "How to Add a New Request on Jobvious" : "How to Create a New Estimate"}
                                         />
                 
                  </div>
                </div>
              </div>,
              document.body
            );
          }
          return null;
        })()}
        
        <div className="d-flex align-items-center justify-content-between d-lg-none d-sm-block p-2 list-header">
          <div className="d-flex align-items-center" style={{ gap: '4px' }}>
            {this.renderRequestimateFilterDropdown(unfilteredList)}
            <button
              className="btn btn-sm btn-header-icon"
              onClick={this.handleRefresh}
              disabled={this.state.refreshing}
              title="Refresh list"
            >
              <i className={`fa-sharp fa-regular fa-refresh ${this.state.refreshing ? 'fa-spin' : ''}`}></i>
            </button>
          </div>
          <h3 className="page-name mb-0">{namePage}</h3>
          {!isEmpty(this.state.selectedRequestimate) ? (
            <button
              type="button"
              className="btn btn-sm btn-header-icon"
              onClick={() => this.handleCancel()}
            >
              <i className="fa-sharp fa-regular fa-times"></i>
            </button>
          ) : (
            <span style={{ width: '32px' }}></span>
          )}
        </div>

        <div className="row">
          <div className="col-lg-4 text-center d-none d-lg-block">
            {
              <div className="d-flex align-items-center justify-content-between p-3 mb-0 corners list-header">
                <span style={{ width: '32px' }}></span>
                <h5 className="page-name mb-0">{namePage}</h5>
                <div className="d-flex align-items-center" style={{ gap: '4px' }}>
                  {this.renderRequestimateFilterDropdown(unfilteredList)}
                  <button
                    className="btn btn-sm btn-header-icon"
                    onClick={this.handleRefresh}
                    disabled={this.state.refreshing}
                    title="Refresh list"
                  >
                    <i className={`fa-sharp fa-regular fa-refresh ${this.state.refreshing ? 'fa-spin' : ''}`}></i>
                  </button>
                </div>
              </div>
            }
            <ul className="list-group-fluid p-0 list-group-flush shadow bg-white corners">
              {(mode === "requests" || mode === "jobs" || mode === "pickups") &&
                userType === "dealer" &&
                this.props.user.access !== "ASSIST" && (
                  <li className="list-group-item d-flex justify-content-center align-items-center corners">
                    <Link
                      to="/newrequestimates/"
                      className="btn btn-success mt-2 mb-2"
                    >
                      NEW REQUEST
                    </Link>
                    {userType === "dealer" && (
                      <button
                        type="button"
                        onClick={this.handleShowHelpVideo}
                        className="btn btn-link p-1 ml-2"
                        title="Click for help video"
                        style={{ fontSize: '16px', color: '#6c757d' }}
                      >
                        <i className="fa-sharp fa-solid fa-circle-question"></i>
                      </button>
                    )}
                  </li>
                )}
              {(mode === "requests" || mode === "jobs" || mode === "pickups") &&
                userType === "installer" &&
                this.props.user.access !== "ASSIST" &&
                !isAllLocations(this.props.selectedLocationId) && (
                  <li className="list-group-item d-flex justify-content-center align-items-center corners">
                    <Link
                      to="/newestimate/"
                      className="btn btn-success mt-2 mb-2"
                    >
                      NEW ESTIMATE
                    </Link>
                    <button
                      type="button"
                      onClick={this.handleShowHelpVideo}
                      className="btn btn-link p-1 ml-2"
                      title="Click for help video"
                      style={{ fontSize: '16px', color: '#6c757d' }}
                    >
                      <i className="fa-sharp fa-solid fa-circle-question"></i>
                    </button>
                  </li>
                )}
              {requestimateList.map((item) => (
                <li
                  onClick={() => this.handleRequestimateSelect(item)}
                  key={item.requestId}
                  className={
                    item.requestId === this.state.selectedRequestimate.requestId
                      ? `list-group-item active ${getSourceClass(item)}`
                      : `list-group-item ${getSourceClass(item)}`
                  }
                >
                  <small>
                    <div className="row">
                      <div className="col-2">
                        <b className={this.getDisplayDate(item, mode).isSame(moment(), 'day') ? 'date-today' : ''}>
                          {this.getDisplayDate(item, mode).format(
                            "ddd MMM D"
                          )}
                        </b>
                      </div>
                      <div className="col-8">
                        <div className="row">
                          <div className="col">
                            <div>{item.serviceRequested}</div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col">
                            <div>
                              {item.vehicleColor && `${item.vehicleColor} `}{item.vehicleYear} {item.vehicleMake}{" "}
                              {item.vehicleModel}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col">
                            {userType === "installer" && (
                              <div>{item.dealerName}</div>
                            )}
                            {userType === "dealer" && (
                              <div>{item.installerName}</div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-2 text-center">
                        {this.iconState(item.currentState)}
                        {multiLoc && (
                          isUnclaimed(item) ? (
                            <div className="mt-1">
                              <span className="badge" style={{ backgroundColor: '#6c757d', color: '#fff', fontSize: '0.65rem' }}>
                                Unclaimed
                              </span>
                            </div>
                          ) : allLocView && (
                            <div className="mt-1">
                              <span
                                className="badge"
                                style={{
                                  backgroundColor: getLocationBadgeColor(item.location_id || item.locationId, this.props.locations),
                                  color: '#fff',
                                  fontSize: '0.65rem'
                                }}
                              >
                                {item.locationName || item.location_name || getLocationName((this.props.locations || []).find(l => String(l.location_id) === String(item.location_id || item.locationId)))}
                              </span>
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  </small>
                </li>
              ))}
            </ul>
          </div>

          {this.state.hiddenList === false && (
            <div className="col-lg-4 text-center d-lg-none d-sm-block">
              <ul className="list-group-fluid p-0 list-group-flush shadow bg-white">
                {(mode === "requests" ||
                  mode === "jobs" ||
                  mode === "pickups") &&
                  userType === "dealer" &&
                  this.props.user.access !== "ASSIST" && (
                    <li className="list-group-item d-flex justify-content-center align-items-center">
                      <Link
                        to="/newrequestimates/"
                        className="btn btn-success btn-lg mt-2 mb-2"
                      >
                        NEW REQUEST
                      </Link>
                      {userType === "dealer" && (
                        <button
                          type="button"
                          onClick={this.handleShowHelpVideo}
                          className="btn btn-link p-1 ml-2"
                          title="Click for help video"
                          style={{ fontSize: '18px', color: '#6c757d' }}
                        >
                          <i className="fa-sharp fa-solid fa-circle-question"></i>
                        </button>
                      )}
                    </li>
                  )}
                {(mode === "requests" ||
                  mode === "jobs" ||
                  mode === "pickups") &&
                  userType === "installer" &&
                  this.props.user.access !== "ASSIST" &&
                  !isAllLocations(this.props.selectedLocationId) && (
                    <li className="list-group-item d-flex justify-content-center align-items-center">
                      <Link
                        to="/newestimate/"
                        className="btn btn-success mt-2 mb-2"
                      >
                        NEW ESTIMATE
                      </Link>
                      <button
                        type="button"
                        onClick={this.handleShowHelpVideo}
                        className="btn btn-link p-1 ml-2"
                        title="Click for help video"
                        style={{ fontSize: '18px', color: '#6c757d' }}
                      >
                        <i className="fa-sharp fa-solid fa-circle-question"></i>
                      </button>
                    </li>
                  )}

                {requestimateList.map((item) => (
                  <li
                    onClick={() => this.handleRequestimateSelect(item, true)}
                    key={item.requestId}
                    className={
                      item.requestId ===
                      this.state.selectedRequestimate.requestId
                        ? `list-group-item active ${getSourceClass(item)}`
                        : `list-group-item ${getSourceClass(item)}`
                    }
                  >
                    <small>
                      <div className="row">
                        <div className="col-2">
                          <b className={this.getDisplayDate(item, mode).isSame(moment(), 'day') ? 'date-today' : ''}>
                            {this.getDisplayDate(item, mode).format(
                              "ddd MMM D"
                            )}
                          </b>
                        </div>
                        <div className="col-8">
                          <div className="row">
                            <div className="col">
                              <div>{item.serviceRequested}</div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col">
                              <div>
                                {item.vehicleColor && `${item.vehicleColor} `}{item.vehicleYear} {item.vehicleMake}{" "}
                                {item.vehicleModel}
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col">
                              {userType === "installer" && (
                                <div>{item.dealerName}</div>
                              )}
                              {userType === "dealer" && (
                                <div>{item.installerName}</div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-2 text-center">
                          {this.iconState(item.currentState)}
                          {multiLoc && (
                            isUnclaimed(item) ? (
                              <div className="mt-1">
                                <span className="badge" style={{ backgroundColor: '#6c757d', color: '#fff', fontSize: '0.65rem' }}>
                                  Unclaimed
                                </span>
                              </div>
                            ) : allLocView && (
                              <div className="mt-1">
                                <span
                                  className="badge"
                                  style={{
                                    backgroundColor: getLocationBadgeColor(item.location_id || item.locationId, this.props.locations),
                                    color: '#fff',
                                    fontSize: '0.65rem'
                                  }}
                                >
                                  {item.locationName || item.location_name || getLocationName((this.props.locations || []).find(l => String(l.location_id) === String(item.location_id || item.locationId)))}
                                </span>
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    </small>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* Mobile: only show when selected. Desktop: always show */}
          <div className={isEmpty(this.state.selectedRequestimate) ? "col-lg-8 d-none d-lg-block" : "col-lg-8"}>
            {/* When nothing selected, just show the message */}
            {isEmpty(this.state.selectedRequestimate) && (
              <Requestimate
                selectedRequestimate={this.state.selectedRequestimate}
                calendarDays={(this.state.requestCalendarDays && this.state.requestCalendarDays.length > 0) ? this.state.requestCalendarDays : this.state.calendarDays}
                displayedList={requestimateList}
                offers={this.state.requestOffers}
                services={this.state.services}
                notes={this.state.requestNotes}
                installer={this.state.installer}
                invoice={this.state.invoice}
                mode={mode}
                userType={userType}
                typeId={typeId}
                onCancel={this.handleCancel}
                vehicleImages={this.state.vehicleImages}
                history={this.state.requestStates}
                locations={this.props.locations}
              />
            )}

            {/* When something is selected, show full detail panels */}
            {!isEmpty(this.state.selectedRequestimate) && (
              <React.Fragment>
                <div className="shadow-sm p-2 corners detail-panel-selected">
                  {/* Mobile back button - visible only on small screens */}
                  <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm d-lg-none mb-2"
                    onClick={() => this.handleCancel()}
                  >
                    <i className="fa-sharp fa-regular fa-arrow-left mr-2"></i>
                    Back to List
                  </button>

                  {/* Desktop close button - visible only on large screens */}
                  <button
                    type="button"
                    className="close d-none d-lg-block"
                    onClick={() => this.handleCancel()}
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <br />
                  <Requestimate
                    selectedRequestimate={this.state.selectedRequestimate}
                    calendarDays={(this.state.requestCalendarDays && this.state.requestCalendarDays.length > 0) ? this.state.requestCalendarDays : this.state.calendarDays}
                    displayedList={requestimateList}
                    offers={this.state.requestOffers}
                    services={this.state.services}
                    notes={this.state.requestNotes}
                    installer={this.state.installer}
                    invoice={this.state.invoice}
                    mode={mode}
                    userType={userType}
                    typeId={typeId}
                    onCancel={this.handleCancel}
                    vehicleImages={this.state.vehicleImages}
                    history={this.state.requestStates}
                  />
                </div>
                <div className="shadow-sm p-3 corners bg-white">
                  {/* Location badge — Unclaimed always in multi-loc; location name only in All Locations view */}
                  {multiLoc && (
                    isUnclaimed(this.state.selectedRequestimate) ? (
                      <span className="badge mb-2" style={{ backgroundColor: '#6c757d', color: '#fff', fontSize: '0.8rem' }}>
                        <i className="fa-sharp fa-regular fa-location-dot mr-1"></i>
                        Unclaimed
                      </span>
                    ) : allLocView && this.state.selectedRequestimate?.location_id ? (
                      <span
                        className="badge mb-2"
                        style={{
                          backgroundColor: getLocationBadgeColor(this.state.selectedRequestimate.location_id, this.props.locations),
                          color: '#fff',
                          fontSize: '0.8rem'
                        }}
                      >
                        <i className="fa-sharp fa-regular fa-location-dot mr-1"></i>
                        {this.state.selectedRequestimate.location_name || getLocationName(
                          (this.props.locations || []).find(l => String(l.location_id) === String(this.state.selectedRequestimate.location_id))
                        )}
                      </span>
                    ) : null
                  )}
                  <RequestimateState
                  userType={userType}
                  typeId={typeId}
                  userAccess={this.props.user.access}
                  userRole={this.props.user.role || this.props.user.user_role}
                  installer={this.state.installer}
                  request={this.state.selectedRequestimate}
                  services={this.state.services}
                  notes={this.state.requestNotes}
                  displayedList={requestimateList}
                  offers={this.state.requestOffers}
                  history={this.state.requestStates}
                  routerHistory={this.props.history}
                  invoice={this.state.invoice}
                  calendarDays={this.state.requestCalendarDays}
                  excludeDays={this.state.excludeDays}
                  startDate={this.state.startDate}
                  paymentIntentId={this.state.paymentIntentId}
                  onStartDateChange={this.handlePickStartDate}
                  template={this.state.template}
                  onTemplateChange={this.handleTemplateChange}
                  materials={this.state.materials}
                  onMaterialsChange={this.handleMaterialsChange}
                  name={this.state.customerName}
                  email={this.state.customerEmail}
                  phone={this.state.customerPhone}
                  onNameChange={this.handleNameChange}
                  onEmailChange={this.handleEmailChange}
                  onPhoneChange={this.handlePhoneChange}
                  reviewScore={this.state.reviewScore}
                  selectedPay={this.state.selectedPay}
                  checkNumber={this.state.checkNumber}
                  onReviewScoreChange={this.handleReviewChange}
                  onPaymentChange={this.handlePaymentChange}
                  onCheckNumberChange={this.handleCheckNumberChange}
                  activePage={this.state.activePage}
                  onPageChange={this.handlePageChange}
                  onDelete={this.handleDelete}
                  onAccept={this.handleAccept}
                  onAcceptEstimate={this.handleAcceptEstimate}
                  onCompleteEstimate={this.handleCompleteEstimate}
                  onReject={this.handleReject}
                  onReschedule={this.handleReschedule}
                  onDealerReschedule={this.handleDealerReschedule}
                  canDealerReschedule={this.canDealerReschedule}
                  onSelectOffer={this.handleSelect}
                  onSelectService={this.handleSelectService}
                  onSelectInstaller={this.handleSelectInstaller}
                  selectedInstaller={this.state.selectedInstaller}
                  selectedService={this.state.selectedService}
                  rowSelected={this.state.rowSelected}
                  onAssign={this.handleAssign}
                  onReceive={this.handleReceive}
                  onResend={this.handleResend}
                  onVINChange={this.handleVINChange}
                  vin={this.state.vin}
                  vehicleEntered={this.state.vehicleEntered}
                  vinGood={this.state.vinGood}
                  onStart={this.handleStart}
                  onFinish={this.handleFinish}
                  onComplete={this.handleComplete}
                  onReview={this.handleReview}
                  onFinalize={this.handleFinalize}
                  onPayment={this.handlePayment}
                  onSettle={this.handleSettle}
                  onDeliver={this.handleDeliver}
                  onCancel={this.handleCancel}
                  showSwipe={this.state.showSwipe}
                  closeSwipe={this.handleCloseSwipe}
                  paymentState={this.state.paymentState}
                  paymentError={this.state.paymentError}
                  onRetryPayment={this.handleRetryPayment}
                  onCancelTerminal={this.handleCancelTerminal}
                  showPO={this.state.showPO}
                  closePO={this.handleClosePO}
                  onAddPO={this.handlePurchaseOrder}
                  onPO={this.handleAddPO}
                  onEdit={this.handleEdit}
                  loading={this.state.loading}
                  availability={this.state.availability}
                  showDepositModal={this.state.showDepositModal}
                  onShowDepositModal={this.handleShowDepositModal}
                  onHideDepositModal={this.handleHideDepositModal}
                  onSaveDeposit={this.handleSaveDeposit}
                  onCreateDepositInvoice={this.handleCreateDepositInvoice}
                  company={this.props.company}
                  onTransferLocation={this.handleTransferLocation}

                  isSplitPayment={this.state.isSplitPayment}
                  collectedPayments={this.state.collectedPayments}
                  splitPaymentAmount={this.state.splitPaymentAmount}
                  selectedSplitMethod={this.state.selectedSplitMethod}
                  splitCheckNumber={this.state.splitCheckNumber}
                  finalInvoiceId={this.state.finalInvoiceId}
                  isProcessingSplitPayment={this.state.isProcessingSplitPayment}
                  splitPaymentError={this.state.splitPaymentError}
                  remainingBalance={this.calculateRemainingBalance()}
                  canUseSplitPayment={this.shouldLoadPaymentData()}
                  onToggleSplitPayment={this.handleToggleSplitPayment}
                  onCollectSplitPayment={this.handleCollectSplitPayment}
                  onSplitMethodChange={(method) => this.setState({ selectedSplitMethod: method })}
                  onSplitAmountChange={(amount) => this.setState({ splitPaymentAmount: amount })}
                  onSplitCheckNumberChange={(num) => this.setState({ splitCheckNumber: num })}
                  showInvoiceLinkModal={this.state.showInvoiceLinkModal}
                  currentInvoiceLink={this.state.currentInvoiceLink}
                  onCloseInvoiceLinkModal={this.handleCloseInvoiceLinkModal}
                  onSendQuote={this.handleSendQuote}
                  onDownloadQuotePdf={this.handleDownloadQuotePdf}

                  technicians={this.state.technicians}
                  onAssignTechnician={this.handleAssignTechnician}
                  onSaveInstructions={this.handleSaveInstructions}
                  savingInstructions={this.state.savingInstructions}

                  categoryHasProducts={this.state.categoryHasProducts}
                  onSelectProduct={this.handleSelectProduct}
                  locations={this.props.locations}
                  selectedLocationId={this.props.selectedLocationId}

                  checkinOdometerReading={this.state.checkinOdometerReading}
                  checkinPlate={this.state.checkinPlate}
                  checkinCarfaxOptOut={this.state.checkinCarfaxOptOut}
                />
                </div>
              </React.Fragment>
            )}
          </div>
        </div>
        <SelectCalendar
          calendars={this.state.userCalendars}
          showList={this.state.showCalendar}
          onHide={this.handleCloseSwipe}
          onSelectCalendar={this.handleSelectCalendar}
        />
        <DeleteOrLossModal
          show={this.state.showDeleteOrLossModal}
          request={this.state.requestToDelete}
          mode="delete"
          onHide={() => this.setState({ showDeleteOrLossModal: false, requestToDelete: null })}
          onConfirm={this.handleDeleteConfirm}
        />
        <DepositRefundModal
          show={this.state.showDepositRefundModal}
          request={this.state.requestToDelete}
          depositPayment={this.state.depositRefundPayment}
          onHide={this.handleRefundCancel}
          onRefundDecision={this.handleRefundDecision}
        />
        <DeleteOrLossModal
          show={this.state.showRejectModal}
          request={this.state.requestToReject}
          mode="reject"
          onHide={() => this.setState({ showRejectModal: false, requestToReject: null })}
          onConfirm={this.handleRejectConfirm}
        />
        {/* Per-Item Material Capture Modal */}
        {this.state.showItemCaptureModal && this.state.itemCaptureService && (
          <ItemMaterialCaptureModal
            show={this.state.showItemCaptureModal}
            onHide={() => this.setState({
              showItemCaptureModal: false,
              itemCaptureService: null,
              itemCaptureItems: [],
              itemCaptureRequest: null,
              itemCaptureJob: null
            })}
            service={this.state.itemCaptureService}
            items={this.state.itemCaptureItems}
            categoryConfig={this.state.categoryConfigs[this.state.itemCaptureService.service_category]}
            installerId={this.state.typeId}
            onComplete={this.handleItemCaptureComplete}
          />
        )}

        {/* Service Items Modal (cube button) */}
        {this.state.showServiceItemsModal && this.state.serviceItemsModalService && (
          <ServiceItemsModal
            show={this.state.showServiceItemsModal}
            onHide={() => this.setState({ showServiceItemsModal: false, serviceItemsModalService: null })}
            service={this.state.serviceItemsModalService}
            installerId={this.state.typeId}
            locationId={this.props.selectedLocationId}
            onItemsChanged={this.handleItemsChanged}
            readOnly={
              this.state.serviceItemsModalService?.service_state === 'finished' ||
              this.state.serviceItemsModalService?.service_state === 'completed'
            }
          />
        )}

        {/* Item Completion Guard Modal */}
        {this.state.showItemGuardModal && this.state.itemGuardData && (
          <ItemCompletionGuardModal
            show={this.state.showItemGuardModal}
            onHide={() => this.setState({ showItemGuardModal: false, itemGuardData: null })}
            serviceName={this.state.itemGuardData.serviceName}
            taskStatus={this.state.itemGuardData.taskStatus}
            onForceComplete={this.state.itemGuardData.retryCallback}
          />
        )}

        {/* VIN Required Modal */}
        {this.state.showVINRequiredModal && this.state.vinRequiredRequest && (
          <VINRequiredModal
            show={this.state.showVINRequiredModal}
            onHide={() => this.setState({ showVINRequiredModal: false, vinRequiredRequest: null, vinRequiredStartDate: null })}
            requestId={this.state.vinRequiredRequest.requestId}
            request={this.state.vinRequiredRequest}
            onVINVerified={this.handleVINVerifiedForComplete}
            onSkip={this.handleVINSkipForComplete}
          />
        )}

        {/* CarFax Data Modal */}
        {this.state.showCarFaxDataModal && this.state.carfaxDataRequest && (
          <CarFaxDataModal
            show={this.state.showCarFaxDataModal}
            requestId={this.state.carfaxDataRequest.requestId}
            request={this.state.carfaxDataRequest}
            company={this.props.company}
            existingOdometer={this.state.checkinOdometerReading}
            existingPlate={this.state.checkinPlate}
            onComplete={this.handleCarFaxDataComplete}
          />
        )}

        {/* Assign / Transfer Location Modal */}
        {multiLoc && (() => {
          const req = this.state.assignLocationRequest;
          const isTransfer = req && !isUnclaimed(req);
          const currentLocId = req ? String(req.location_id || req.locationId || '') : '';
          const availableLocations = isTransfer
            ? (this.props.locations || []).filter(loc => String(loc.location_id) !== currentLocId)
            : (this.props.locations || []);

          return (
            <Modal
              show={this.state.showAssignLocationModal}
              onHide={() => this.setState({ showAssignLocationModal: false, assignLocationRequest: null, assignLocationCallback: null, modalSelectedLocationId: '' })}
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>{isTransfer ? 'Transfer to Location' : 'Assign Location'}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>{isTransfer
                  ? 'Select the location to transfer this request to.'
                  : 'This request must be assigned to a location before you can proceed.'
                }</p>
                <Form.Group>
                  <Form.Label>Select a location</Form.Label>
                  <Form.Control
                    as="select"
                    value={this.state.modalSelectedLocationId || ''}
                    onChange={(e) => this.setState({ modalSelectedLocationId: e.target.value })}
                  >
                    <option value="" disabled>Choose location...</option>
                    {availableLocations.map(loc => (
                      <option key={loc.location_id} value={loc.location_id}>
                        {getLocationName(loc)}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => this.setState({ showAssignLocationModal: false, assignLocationRequest: null, assignLocationCallback: null, modalSelectedLocationId: '' })}
                >
                  Cancel
                </Button>
                <Button
                  variant="success"
                  disabled={!this.state.modalSelectedLocationId}
                  onClick={async () => {
                    const locId = Number(this.state.modalSelectedLocationId);
                    const { assignLocationRequest, assignLocationCallback } = this.state;
                    if (!locId || !assignLocationRequest) return;
                    await this.handleAssignLocation(assignLocationRequest, locId);
                    this.setState({ showAssignLocationModal: false, assignLocationRequest: null, assignLocationCallback: null, modalSelectedLocationId: '' });
                    if (assignLocationCallback) assignLocationCallback();
                  }}
                >
                  {isTransfer ? 'TRANSFER' : 'ASSIGN & CONTINUE'}
                </Button>
              </Modal.Footer>
            </Modal>
          );
        })()}
      </React.Fragment>
    );
  }
}
export default withRouter(Requestimates);